<template>
  <button :disabled="disabled" :type="type || 'button'" class="c-button" :class="buttonStyles" @click="onClick">
    <div
      v-if="icon !== undefined"
      class="c-button-icon"
      :class="iconStyles"
      :style="{ top: icon === 'edit-worker' ? 'auto' : '', left: icon === 'edit-worker' ? '25%' : '' }"
    >
      <svg
        v-if="(icon.icon && icon.icon === 'check') || icon === 'check'"
        width="14"
        height="10"
        viewBox="0 0 15 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.26585 9.68401C4.87533 9.29348 4.87533 8.66032 5.26585 8.2698L13.0859 0.449632C13.4764 0.0591074 14.1096 0.059107 14.5001 0.449631C14.8906 0.840156 14.8906 1.47332 14.5001 1.86384L6.68006 9.68401C6.28954 10.0745 5.65637 10.0745 5.26585 9.68401Z"
        />
        <path
          d="M6.68006 9.68401C7.07059 9.29348 7.07053 8.66032 6.68001 8.2698L2.50007 4.08989C2.10955 3.69937 1.47639 3.69937 1.08586 4.08989C0.695338 4.48042 0.695338 5.11358 1.08586 5.50411L5.26585 9.68401C5.65637 10.0745 6.28954 10.0745 6.68006 9.68401Z"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'edit-worker') || icon === 'edit-worker'"
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5596 8.9187L12.8525 8.2116L12.8525 8.2116L13.5596 8.9187ZM16 9.92954H17H16ZM15.5813 10.9404L14.8742 10.2333L14.8742 10.2333L15.5813 10.9404ZM10.7798 15.7419L11.0429 16.7066C11.2108 16.6608 11.3639 16.572 11.4869 16.449L10.7798 15.7419ZM8 16.5L7.03524 16.2369C6.94081 16.5831 7.03914 16.9534 7.29289 17.2071C7.54664 17.4609 7.9169 17.5592 8.26312 17.4648L8 16.5ZM8.75813 13.7202L8.05102 13.0131C7.92797 13.1361 7.83916 13.2892 7.79337 13.4571L8.75813 13.7202ZM6 12.4863C6.55228 12.4863 7 12.0386 7 11.4863C7 10.934 6.55228 10.4863 6 10.4863V12.4863ZM4.73896 11.4863V10.4863V11.4863ZM1 15.4745H0H1ZM0 16.5625C0 17.1148 0.447715 17.5625 1 17.5625C1.55228 17.5625 2 17.1148 2 16.5625H0ZM14.2667 9.62581C14.3066 9.58592 14.354 9.55428 14.4061 9.5327L13.6407 7.68494C13.3459 7.80703 13.0781 7.98599 12.8525 8.2116L14.2667 9.62581ZM14.4061 9.5327C14.4582 9.51111 14.514 9.5 14.5705 9.5V7.5C14.2514 7.5 13.9355 7.56284 13.6407 7.68494L14.4061 9.5327ZM14.5705 9.5C14.6269 9.5 14.6827 9.51111 14.7348 9.5327L15.5002 7.68494C15.2054 7.56284 14.8895 7.5 14.5705 7.5V9.5ZM14.7348 9.5327C14.787 9.55428 14.8343 9.58592 14.8742 9.62581L16.2884 8.2116C16.0628 7.98599 15.795 7.80703 15.5002 7.68494L14.7348 9.5327ZM14.8742 9.62581C14.9141 9.6657 14.9457 9.71305 14.9673 9.76516L16.8151 8.99979C16.693 8.70503 16.514 8.4372 16.2884 8.2116L14.8742 9.62581ZM14.9673 9.76516C14.9889 9.81727 15 9.87313 15 9.92954H17C17 9.61049 16.9372 9.29457 16.8151 8.99979L14.9673 9.76516ZM15 9.92954C15 9.98595 14.9889 10.0418 14.9673 10.0939L16.8151 10.8593C16.9372 10.5645 17 10.2486 17 9.92954H15ZM14.9673 10.0939C14.9457 10.146 14.9141 10.1934 14.8742 10.2333L16.2884 11.6475C16.514 11.4219 16.693 11.1541 16.8151 10.8593L14.9673 10.0939ZM14.8742 10.2333L10.0727 15.0348L11.4869 16.449L16.2884 11.6475L14.8742 10.2333ZM10.5167 14.7771L7.73688 15.5352L8.26312 17.4648L11.0429 16.7066L10.5167 14.7771ZM8.96476 16.7631L9.72289 13.9833L7.79337 13.4571L7.03524 16.2369L8.96476 16.7631ZM9.46524 14.4273L14.2667 9.62581L12.8525 8.2116L8.05102 13.0131L9.46524 14.4273ZM11.7643 10.7357L13.7643 12.7357L15.1785 11.3215L13.1785 9.32149L11.7643 10.7357ZM6 10.4863H4.73896V12.4863H6V10.4863ZM4.73896 10.4863C3.46052 10.4863 2.24859 11.0286 1.36558 11.9705L2.82465 13.3383C3.34403 12.7843 4.03413 12.4863 4.73896 12.4863V10.4863ZM1.36558 11.9705C0.484619 12.9102 0 14.1716 0 15.4745H2C2 14.6619 2.30323 13.8945 2.82465 13.3383L1.36558 11.9705ZM0 15.4745V16.5625H2V15.4745H0ZM9.95503 4.49117C9.95503 5.59086 9.06355 6.48234 7.96386 6.48234V8.48234C10.1681 8.48234 11.955 6.69543 11.955 4.49117H9.95503ZM7.96386 6.48234C6.86417 6.48234 5.97269 5.59086 5.97269 4.49117H3.97269C3.97269 6.69543 5.7596 8.48234 7.96386 8.48234V6.48234ZM5.97269 4.49117C5.97269 3.39148 6.86417 2.5 7.96386 2.5V0.5C5.7596 0.5 3.97269 2.28691 3.97269 4.49117H5.97269ZM7.96386 2.5C9.06355 2.5 9.95503 3.39148 9.95503 4.49117H11.955C11.955 2.28691 10.1681 0.5 7.96386 0.5V2.5Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'plus') || icon === 'plus'"
        width="14"
        height="14"
        viewBox="0 0 14 15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99697 14.0083C6.44681 14.0083 6.00082 13.5595 6.00082 13.0059L5.99983 1.01071C5.99983 0.457096 6.44582 0.00830078 6.99599 0.00830078C7.54615 0.00830078 7.99215 0.457097 7.99215 1.01071L7.99313 13.0059C7.99313 13.5595 7.54714 14.0083 6.99697 14.0083Z"
        />
        <path
          d="M14 7.01688C14 6.46326 13.554 6.01447 13.0038 6.01447L0.996158 6.01448C0.445995 6.01448 0 6.46327 0 7.01689C0 7.57051 0.445995 8.0193 0.996159 8.0193L13.0038 8.0193C13.554 8.0193 14 7.5705 14 7.01688Z"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'plus-bold') || icon === 'plus-bold'"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.99697 9.99975C4.44681 9.99975 4.00082 9.55096 4.00082 8.99734L3.99983 1.00217C3.99983 0.448551 4.44582 -0.000244141 4.99599 -0.000244141C5.54615 -0.000244141 5.99215 0.448552 5.99215 1.00217L5.99313 8.99734C5.99313 9.55096 5.54714 9.99975 4.99697 9.99975Z"
          fill="#0066FF"
        />
        <path
          d="M10 5.00834C10 4.45472 9.55401 4.00592 9.00384 4.00592L0.996158 4.00593C0.445995 4.00593 0 4.45473 0 5.00835C0 5.56196 0.445995 6.01076 0.996159 6.01076L9.00384 6.01075C9.55401 6.01075 10 5.56195 10 5.00834Z"
          fill="#0066FF"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'times-bold') || icon === 'times-bold'"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.53342 7.53743C7.14439 7.92645 6.51168 7.92447 6.12021 7.53301L0.466074 1.88026C0.0746075 1.4888 0.0726278 0.856083 0.461652 0.467059C0.850676 0.0780348 1.48339 0.0800154 1.87486 0.471482L7.52899 6.12423C7.92046 6.51569 7.92244 7.1484 7.53342 7.53743Z"
          fill="#8E9CBB"
        />
        <path
          d="M7.54162 0.47029C7.15016 0.0788231 6.51745 0.0768422 6.12842 0.465866L0.466139 6.12816C0.0771151 6.51718 0.0790961 7.1499 0.470563 7.54136C0.862029 7.93283 1.49474 7.93481 1.88377 7.54579L7.54605 1.88349C7.93507 1.49447 7.93309 0.861756 7.54162 0.47029Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'filter') || icon === 'filter'"
        width="14"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1L12.7855 1.61885C13.0226 1.31795 13.0669 0.908077 12.8997 0.563449C12.7325 0.21882 12.3831 0 12 0V1ZM1 1V0C0.616259 0 0.266364 0.219593 0.0994958 0.565153C-0.0673727 0.910712 -0.0217795 1.32128 0.216836 1.62182L1 1ZM5.01983 6.06289H6.01983C6.01983 5.83708 5.9434 5.61792 5.80299 5.44108L5.01983 6.06289ZM5.01983 10.0252H4.01983C4.01983 10.4581 4.29839 10.8418 4.70999 10.9759L5.01983 10.0252ZM8.01133 11L7.7015 11.9508C8.00599 12.05 8.33959 11.9974 8.59877 11.8093C8.85794 11.6211 9.01133 11.3203 9.01133 11H8.01133ZM8.01133 6.06289L7.22582 5.44405C7.08688 5.6204 7.01133 5.83838 7.01133 6.06289H8.01133ZM12 0H1V2H12V0ZM0.216836 1.62182L4.23667 6.68471L5.80299 5.44108L1.78316 0.378185L0.216836 1.62182ZM4.01983 6.06289V10.0252H6.01983V6.06289H4.01983ZM4.70999 10.9759L7.7015 11.9508L8.32117 10.0492L5.32966 9.07437L4.70999 10.9759ZM9.01133 11V6.06289H7.01133V11H9.01133ZM8.79684 6.68174L12.7855 1.61885L11.2145 0.381154L7.22582 5.44405L8.79684 6.68174Z"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'filter-drop') || icon === 'filter-drop'"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1L12.7855 1.61885C13.0226 1.31795 13.0669 0.908077 12.8997 0.563449C12.7325 0.21882 12.3831 0 12 0V1ZM1 1V0C0.616259 0 0.266364 0.219593 0.0994958 0.565153C-0.0673727 0.910712 -0.0217795 1.32128 0.216836 1.62182L1 1ZM5.01983 6.06289H6.01983C6.01983 5.83708 5.9434 5.61792 5.80299 5.44108L5.01983 6.06289ZM5.01983 10.0252H4.01983C4.01983 10.4581 4.29839 10.8418 4.70999 10.9759L5.01983 10.0252ZM8.01133 11L7.7015 11.9508C8.00599 12.05 8.33959 11.9974 8.59877 11.8093C8.85794 11.6211 9.01133 11.3203 9.01133 11H8.01133ZM8.01133 6.06289L7.22582 5.44405C7.08688 5.6204 7.01133 5.83838 7.01133 6.06289H8.01133ZM14.7624 7.77686C15.1569 7.39038 15.1634 6.75725 14.7769 6.36272C14.3905 5.96819 13.7573 5.96166 13.3628 6.34814L14.7624 7.77686ZM10.3003 9.34814C9.90577 9.73462 9.89924 10.3678 10.2857 10.7623C10.6722 11.1568 11.3053 11.1633 11.6999 10.7769L10.3003 9.34814ZM11.66 6.34776C11.2609 5.966 10.6279 5.98005 10.2461 6.37915C9.86436 6.77825 9.87842 7.41126 10.2775 7.79302L11.66 6.34776ZM13.34 10.7225C13.7391 11.1042 14.3721 11.0902 14.7539 10.6911C15.1356 10.292 15.1216 9.65896 14.7225 9.2772L13.34 10.7225ZM12 0H1V2H12V0ZM0.216836 1.62182L4.23667 6.68471L5.80299 5.44108L1.78316 0.378185L0.216836 1.62182ZM4.01983 6.06289V10.0252H6.01983V6.06289H4.01983ZM4.70999 10.9759L7.7015 11.9508L8.32117 10.0492L5.32966 9.07437L4.70999 10.9759ZM9.01133 11V6.06289H7.01133V11H9.01133ZM8.79684 6.68174L12.7855 1.61885L11.2145 0.381154L7.22582 5.44405L8.79684 6.68174ZM13.3628 6.34814L11.8302 7.84944L13.2298 9.27816L14.7624 7.77686L13.3628 6.34814ZM11.8302 7.84944L10.3003 9.34814L11.6999 10.7769L13.2298 9.27816L11.8302 7.84944ZM10.2775 7.79302L11.8388 9.28643L13.2212 7.84117L11.66 6.34776L10.2775 7.79302ZM11.8388 9.28643L13.34 10.7225L14.7225 9.2772L13.2212 7.84117L11.8388 9.28643Z"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'bookmark') || icon === 'bookmark'"
        class="c-button-icon_stroked"
        width="12"
        height="14"
        viewBox="0 0 12 15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 13.8571L6 10.2857L1 13.8571V2.42857C1 2.04969 1.15051 1.68633 1.41842 1.41842C1.68633 1.15051 2.04969 1 2.42857 1H9.57143C9.95031 1 10.3137 1.15051 10.5816 1.41842C10.8495 1.68633 11 2.04969 11 2.42857V13.8571Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'favorites') || icon === 'favorites'"
        class="c-button-icon_stroked"
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.94076 1.5L12.5401 6.76604L18.353 7.61567L14.1469 11.7124L15.1395 17.5L9.94076 14.766L4.74202 17.5L5.73466 11.7124L1.52856 7.61567L7.34139 6.76604L9.94076 1.5Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'menu') || icon === 'menu'"
        class="c-button-icon_stroked"
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1H11M1 5H11M1 9H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'chart') || icon === 'chart'"
        class="c-button-icon_stroked"
        width="14"
        height="12"
        viewBox="0 0 14 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1L1 11M5 5L5 11M9 3V11M13 7V11" stroke-width="2" stroke-linecap="round" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'cog') || icon === 'cog'"
        class="c-button-icon_stroked"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5686 9.90909C9.62297 9.90909 10.4777 9.05436 10.4777 8C10.4777 6.94564 9.62297 6.09091 8.5686 6.09091C7.51424 6.09091 6.65951 6.94564 6.65951 8C6.65951 9.05436 7.51424 9.90909 8.5686 9.90909Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.2777 9.90909C13.193 10.101 13.1677 10.3139 13.2051 10.5204C13.2426 10.7268 13.341 10.9173 13.4877 11.0673L13.5259 11.1055C13.6442 11.2237 13.7381 11.364 13.8021 11.5185C13.8662 11.673 13.8991 11.8387 13.8991 12.0059C13.8991 12.1732 13.8662 12.3388 13.8021 12.4933C13.7381 12.6478 13.6442 12.7882 13.5259 12.9064C13.4077 13.0247 13.2673 13.1186 13.1128 13.1826C12.9583 13.2467 12.7927 13.2796 12.6254 13.2796C12.4582 13.2796 12.2926 13.2467 12.138 13.1826C11.9835 13.1186 11.8432 13.0247 11.725 12.9064L11.6868 12.8682C11.5368 12.7215 11.3463 12.6231 11.1399 12.5856C10.9335 12.5482 10.7205 12.5735 10.5286 12.6582C10.3404 12.7388 10.1799 12.8728 10.0668 13.0435C9.95373 13.2143 9.89306 13.4143 9.89224 13.6191V13.7273C9.89224 14.0648 9.75815 14.3885 9.51947 14.6272C9.28078 14.8659 8.95706 15 8.61951 15C8.28196 15 7.95824 14.8659 7.71956 14.6272C7.48088 14.3885 7.34679 14.0648 7.34679 13.7273V13.67C7.34186 13.4594 7.27368 13.2551 7.15111 13.0837C7.02854 12.9123 6.85725 12.7818 6.65951 12.7091C6.46758 12.6244 6.25466 12.5991 6.04823 12.6365C5.8418 12.674 5.65131 12.7724 5.50133 12.9191L5.46315 12.9573C5.34495 13.0756 5.20458 13.1695 5.05007 13.2335C4.89557 13.2976 4.72995 13.3305 4.56269 13.3305C4.39544 13.3305 4.22982 13.2976 4.07532 13.2335C3.92081 13.1695 3.78044 13.0756 3.66224 12.9573C3.54391 12.8391 3.45003 12.6987 3.38598 12.5442C3.32193 12.3897 3.28897 12.2241 3.28897 12.0568C3.28897 11.8896 3.32193 11.7239 3.38598 11.5694C3.45003 11.4149 3.54391 11.2746 3.66224 11.1564L3.70042 11.1182C3.84713 10.9682 3.94554 10.7777 3.98297 10.5713C4.0204 10.3649 3.99513 10.1519 3.91042 9.96C3.82975 9.77178 3.69581 9.61126 3.52508 9.4982C3.35435 9.38513 3.15429 9.32445 2.94951 9.32364H2.84133C2.50378 9.32364 2.18006 9.18955 1.94138 8.95086C1.70269 8.71218 1.5686 8.38846 1.5686 8.05091C1.5686 7.71336 1.70269 7.38964 1.94138 7.15096C2.18006 6.91227 2.50378 6.77818 2.84133 6.77818H2.8986C3.10924 6.77325 3.31352 6.70508 3.48488 6.58251C3.65625 6.45994 3.78679 6.28865 3.85951 6.09091C3.94422 5.89897 3.96949 5.68606 3.93206 5.47963C3.89463 5.27319 3.79622 5.0827 3.64951 4.93273L3.61133 4.89455C3.493 4.77634 3.39912 4.63598 3.33507 4.48147C3.27102 4.32696 3.23806 4.16135 3.23806 3.99409C3.23806 3.82683 3.27102 3.66122 3.33507 3.50671C3.39912 3.35221 3.493 3.21184 3.61133 3.09364C3.72953 2.9753 3.8699 2.88143 4.02441 2.81738C4.17891 2.75333 4.34453 2.72036 4.51179 2.72036C4.67904 2.72036 4.84466 2.75333 4.99916 2.81738C5.15367 2.88143 5.29404 2.9753 5.41224 3.09364L5.45042 3.13182C5.6004 3.27852 5.79089 3.37694 5.99732 3.41437C6.20375 3.4518 6.41667 3.42653 6.6086 3.34182H6.65951C6.84773 3.26115 7.00825 3.12721 7.12132 2.95648C7.23438 2.78575 7.29506 2.58568 7.29588 2.38091V2.27273C7.29588 1.93518 7.42997 1.61146 7.66865 1.37277C7.90733 1.13409 8.23106 1 8.5686 1C8.90615 1 9.22987 1.13409 9.46856 1.37277C9.70724 1.61146 9.84133 1.93518 9.84133 2.27273V2.33C9.84215 2.53477 9.90282 2.73484 10.0159 2.90557C10.129 3.0763 10.2895 3.21024 10.4777 3.29091C10.6696 3.37562 10.8825 3.40089 11.089 3.36346C11.2954 3.32603 11.4859 3.22761 11.6359 3.08091L11.6741 3.04273C11.7923 2.92439 11.9326 2.83052 12.0871 2.76647C12.2416 2.70242 12.4073 2.66945 12.5745 2.66945C12.7418 2.66945 12.9074 2.70242 13.0619 2.76647C13.2164 2.83052 13.3568 2.92439 13.475 3.04273C13.5933 3.16093 13.6872 3.3013 13.7512 3.4558C13.8153 3.61031 13.8482 3.77593 13.8482 3.94318C13.8482 4.11044 13.8153 4.27605 13.7512 4.43056C13.6872 4.58507 13.5933 4.72543 13.475 4.84364L13.4368 4.88182C13.2901 5.0318 13.1917 5.22228 13.1542 5.42872C13.1168 5.63515 13.1421 5.84806 13.2268 6.04V6.09091C13.3075 6.27913 13.4414 6.43965 13.6121 6.55271C13.7829 6.66578 13.9829 6.72646 14.1877 6.72727H14.2959C14.6334 6.72727 14.9571 6.86136 15.1958 7.10005C15.4345 7.33873 15.5686 7.66245 15.5686 8C15.5686 8.33755 15.4345 8.66127 15.1958 8.89995C14.9571 9.13864 14.6334 9.27273 14.2959 9.27273H14.2386C14.0338 9.27354 13.8338 9.33422 13.663 9.44729C13.4923 9.56035 13.3584 9.72087 13.2777 9.90909Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'close') || icon === 'close'"
        width="12"
        height="12"
        viewBox="0 0 13 13"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.525425 11.6783C0.94995 12.1016 1.63824 12.1016 2.06277 11.6783L11.8886 1.88173C12.3132 1.45841 12.3132 0.772068 11.8886 0.348743C11.4641 -0.0745802 10.7758 -0.0745802 10.3513 0.348743L0.525425 10.1453C0.100901 10.5686 0.100901 11.255 0.525425 11.6783Z"
        />
        <path
          d="M0.593335 0.450393C1.01786 0.0270681 1.70615 0.0270681 2.13068 0.450393L11.8886 10.1808C12.3132 10.6041 12.3132 11.2904 11.8886 11.7138C11.4641 12.1371 10.7758 12.1371 10.3513 11.7138L0.593335 1.98338C0.168811 1.56006 0.168811 0.873716 0.593335 0.450393Z"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'eye') || icon === 'eye'"
        class="c-button-icon_stroked"
        width="20"
        height="12"
        viewBox="0 0 20 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6C18 6 14.4183 11 10 11C5.58172 11 2 6 2 6C2 6 5.58172 1 10 1C14.4183 1 18 6 18 6Z"
          stroke-width="2"
        />
        <path
          d="M13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5Z"
          stroke-width="2"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'trash') || icon === 'trash'"
        width="13"
        height="15"
        viewBox="0 0 13 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V3ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3V5ZM2.92846 3.6C2.92846 4.15228 3.37618 4.6 3.92846 4.6C4.48075 4.6 4.92846 4.15228 4.92846 3.6H2.92846ZM5.21418 1V0V1ZM7.78561 1V0V1ZM8.07132 3.6C8.07132 4.15228 8.51903 4.6 9.07132 4.6C9.6236 4.6 10.0713 4.15228 10.0713 3.6H8.07132ZM6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7H6ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7H9ZM7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11H7ZM1 5H12V3H1V5ZM4.92846 3.6V2.3H2.92846V3.6H4.92846ZM4.92846 2.3C4.92846 2.21689 4.96122 2.13938 5.01604 2.08395L3.59404 0.677572C3.16663 1.10973 2.92846 1.69355 2.92846 2.3H4.92846ZM5.01604 2.08395C5.0705 2.02889 5.14199 2 5.21418 2V0C4.60438 0 4.02182 0.245036 3.59404 0.677572L5.01604 2.08395ZM5.21418 2H7.78561V0H5.21418V2ZM7.78561 2C7.85779 2 7.92929 2.02889 7.98374 2.08395L9.40575 0.677572C8.97796 0.245036 8.3954 0 7.78561 0V2ZM7.98374 2.08395C8.03856 2.13938 8.07132 2.21689 8.07132 2.3H10.0713C10.0713 1.69355 9.83316 1.10973 9.40575 0.677572L7.98374 2.08395ZM8.07132 2.3V3.6H10.0713V2.3H8.07132ZM4 7V11H6V7H4ZM7 7V11H9V7H7ZM10 4V12H12V4H10ZM9 13H4V15H9V13ZM3 12V4H1V12H3ZM4 13C3.44772 13 3 12.5523 3 12H1C1 13.6569 2.34315 15 4 15V13ZM10 12C10 12.5523 9.55228 13 9 13V15C10.6569 15 12 13.6569 12 12H10Z"
          fill="#FF238D"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'edit') || icon === 'edit'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'arrows-constructor') || icon === 'arrows-constructor'"
        width="8"
        height="16"
        viewBox="0 0 8 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.69594 14.7086C4.30473 15.0991 3.67045 15.0991 3.27924 14.7086L0.293409 11.7296C-0.097803 11.339 -0.0978031 10.7059 0.293409 10.3153C0.684621 9.92482 1.3189 9.92482 1.71011 10.3153L4.69594 13.2944C5.08715 13.6849 5.08715 14.318 4.69594 14.7086Z"
          fill="#8E9CBB"
        />
        <path
          d="M3.30385 14.7086C3.69506 15.0991 4.32934 15.0991 4.72055 14.7086L7.70659 11.7296C8.0978 11.339 8.0978 10.7059 7.70659 10.3153C7.31538 9.92482 6.6811 9.92482 6.28989 10.3153L3.30385 13.2944C2.91264 13.6849 2.91264 14.318 3.30385 14.7086Z"
          fill="#8E9CBB"
        />
        <path
          d="M3.98759 14.0157C3.43433 14.0157 2.98583 13.5679 2.98583 13.0157V3C2.98583 2.44772 3.43433 2 3.98759 2C4.54085 2 4.98935 2.44772 4.98935 3V13.0157C4.98935 13.5679 4.54085 14.0157 3.98759 14.0157Z"
          fill="#8E9CBB"
        />
        <path
          d="M4.69594 0.292893C4.30473 -0.0976311 3.67045 -0.0976311 3.27924 0.292893L0.293409 3.27191C-0.097803 3.66243 -0.0978031 4.2956 0.293409 4.68612C0.684621 5.07664 1.3189 5.07664 1.71011 4.68612L4.69594 1.70711C5.08715 1.31658 5.08715 0.683417 4.69594 0.292893Z"
          fill="#8E9CBB"
        />
        <path
          d="M3.30385 0.292893C3.69506 -0.0976311 4.32934 -0.0976311 4.72055 0.292893L7.70659 3.27191C8.0978 3.66243 8.0978 4.2956 7.70659 4.68612C7.31538 5.07664 6.6811 5.07664 6.28989 4.68612L3.30385 1.70711C2.91264 1.31658 2.91264 0.683417 3.30385 0.292893Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'info') || icon === 'info'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="6.5" fill="white" stroke="#D3D8DF" />
        <circle r="1" transform="matrix(1 0 0 -1 7 4)" fill="#0066FF" />
        <rect width="2" height="5" rx="1" transform="matrix(1 0 0 -1 6 11)" fill="#0066FF" />
      </svg>

      <svg v-if="(icon.icon && icon.icon === 'info-new') || icon === 'info-new'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#8E9CBB" stroke-width="2" fill="none"/>
        <path d="M11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6Z" fill="#8E9CBB"/>
        <path d="M9 14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14Z" fill="#8E9CBB"/>
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'filter-tiny') || icon === 'filter-tiny'"
        width="16"
        height="12"
        viewBox="0 0 16 13"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.392 1.31068L14.0338 0.500244H13H3H1.96365L2.60864 1.31143L6.51562 6.22511V10.0002V10.3082L6.79061 10.4468L8.77499 11.4468L9.5 11.8121V11.0002V6.22458L13.392 1.31068Z"
          stroke-linecap="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'constructor') || icon === 'constructor'"
        class="c-button-icon_stroked"
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1H11M1 5H6M1 9H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'groups') || icon === 'groups'"
        class="c-button-icon_stroked"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 8L8 4L4 8M12 8H14C14.5523 8 15 8.44772 15 9V10C15 10.5523 14.5523 11 14 11H12C11.4477 11 11 10.5523 11 10V9C11 8.44772 11.4477 8 12 8ZM4 8H2C1.44772 8 1 8.44772 1 9V10C1 10.5523 1.44772 11 2 11H4C4.55228 11 5 10.5523 5 10V9C5 8.44772 4.55228 8 4 8ZM7 4H9C9.55228 4 10 3.55228 10 3V2C10 1.44772 9.55228 1 9 1H7C6.44772 1 6 1.44772 6 2V3C6 3.55228 6.44772 4 7 4Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'excel') || icon === 'excel'"
        class="c-button-icon_stroked c-button-icon_stroked_success"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.47538 3.125H10.5823L8.05679 6.85381L10.9062 11H8.71957L6.98437 8.43767L5.24813 11H3.0625L5.91196 6.85381L3.38642 3.125H5.49336L6.98437 5.29456L8.47538 3.125Z"
        />
        <path d="M1 13V1H13V13H1Z" stroke-width="2" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'comment') || icon === 'comment'"
        class="c-button-icon_stroked"
        width="17"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4647 1.00024H2.49575C1.67075 1.00024 1 1.67099 1 2.49599V9.47673C1 10.3017 1.67075 10.9725 2.49575 10.9725H5.98612V14.7191C5.98612 14.9481 6.24787 15.0813 6.43251 14.9458L9.97501 10.9725H13.4647C14.2897 10.9725 14.9604 10.3017 14.9604 9.47673V2.49599C14.9604 1.67099 14.2897 1.00024 13.4647 1.00024Z"
          stroke="#8E9CBB"
          stroke-width="2"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'back') || icon === 'back'"
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.307053 5.69471C-0.0834709 5.30419 -0.0834709 4.67103 0.307053 4.2805L4.28607 0.301682C4.67659 -0.088842 5.30976 -0.088842 5.70028 0.301682C6.0908 0.692207 6.0908 1.32537 5.70028 1.7159L1.72127 5.69471C1.33074 6.08524 0.697578 6.08524 0.307053 5.69471Z"
          fill="#8E9CBB"
        />
        <path
          d="M0.307053 4.30507C-0.0834709 4.69559 -0.0834709 5.32876 0.307053 5.71928L4.28607 9.69831C4.67659 10.0888 5.30976 10.0888 5.70028 9.69831C6.0908 9.30779 6.0908 8.67462 5.70028 8.2841L1.72127 4.30507C1.33074 3.91454 0.697578 3.91454 0.307053 4.30507Z"
          fill="#8E9CBB"
        />
        <path
          d="M0.999971 4.98761C0.999971 4.43532 1.44769 3.98761 1.99997 3.98761H12.0156C12.5679 3.98761 13.0156 4.43532 13.0156 4.98761C13.0156 5.53989 12.5679 5.98761 12.0156 5.98761H1.99997C1.44769 5.98761 0.999971 5.53989 0.999971 4.98761Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'time') || icon === 'time'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'calculate') || icon === 'calculate'"
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 5.00024H10M4 8.00024H6M4 11.0002H6M8 8.00024H10M8 11.0002H10M3 15.0002H11C12.1046 15.0002 13 14.1048 13 13.0002V3.00024C13 1.89567 12.1046 1.00024 11 1.00024H3C1.89543 1.00024 1 1.89567 1 3.00024V13.0002C1 14.1048 1.89543 15.0002 3 15.0002Z"
          stroke="#8E9CBB"
          stroke-width="2"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'need') || icon === 'need'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 5V9M5 7H9M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
          stroke="#FFB800"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'time-is-out') || icon === 'time-is-out'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
          stroke="#FF238D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="7" cy="10" r="1" fill="#FF238D" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'explanatory') || icon === 'explanatory'"
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 6H10M4 10H8M1 1V15H13V1H1Z" stroke="#FF238D" stroke-width="2" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'up') || icon === 'up'"
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 11V1M5 1L9 5M5 1L1 5"
          stroke="#FF238D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'link') || icon === 'link'"
        class="c-button-icon_stroked"
        width="18"
        height="10"
        viewBox="0 0 18 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 9H4.75C4.25754 9 3.76991 8.89654 3.31494 8.69552C2.85997 8.4945 2.44657 8.19986 2.09835 7.82843C1.39509 7.07828 1 6.06087 1 5C1 3.93913 1.39509 2.92172 2.09835 2.17157C2.80161 1.42143 3.75544 1 4.75 1H7M11 9H13.25C13.7425 9 14.2301 8.89654 14.6851 8.69552C15.14 8.4945 15.5534 8.19986 15.9017 7.82843C16.6049 7.07828 17 6.06087 17 5C17 3.93913 16.6049 2.92172 15.9017 2.17157C15.1984 1.42143 14.2446 1 13.25 1H11M6 5H12"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'download') || icon === 'download'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.70711 6.29289C4.31658 5.90237 3.68342 5.90237 3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L4.70711 6.29289ZM7 10L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L7 10ZM10.7071 7.70711C11.0976 7.31658 11.0976 6.68342 10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L10.7071 7.70711ZM8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H8ZM14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10H14ZM2 10C2 9.44771 1.55228 9 1 9C0.447715 9 0 9.44771 0 10H2ZM3.29289 7.70711L6.29289 10.7071L7.70711 9.29289L4.70711 6.29289L3.29289 7.70711ZM7.70711 10.7071L10.7071 7.70711L9.29289 6.29289L6.29289 9.29289L7.70711 10.7071ZM8 10V1H6V10H8ZM12 10V12H14V10H12ZM12 12H2V14H12V12ZM2 12V10H0V12H2ZM2 12H2H0C0 13.1046 0.895431 14 2 14V12ZM12 12V14C13.1046 14 14 13.1046 14 12H12Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'change-history') || icon === 'change-history'"
        class="c-button-icon_stroked"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M9 4V7L11 8M1 7L3 9L5 7"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'restore') || icon === 'restore'"
        class="c-button-icon_stroked"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M1 7L3 9L5 7"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'box-arhive') || icon === 'box-arhive'"
        class="c-button-icon_stroked"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.96 8h3m-8-7h13v4h-13V1Zm1 4h11v8h-11V5Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'file') || icon === 'file'"
        class="c-button-icon_stroked"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 14 16"
      >
        <path
          d="M12.96 6.5v8h-11v-13h6m5 5h-5v-5m5 5-5-5"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'mark-as-employee') || icon === 'mark-as-employee'"
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 3.494H0H1ZM5 2.9952C5 3.54749 5.44772 3.9952 6 3.9952C6.55228 3.9952 7 3.54749 7 2.9952H5ZM7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1H7ZM4 8C3.44772 8 3 8.44772 3 9C3 9.55229 3.44772 10 4 10V8ZM8 10C8.55228 10 9 9.55229 9 9C9 8.44772 8.55228 8 8 8V10ZM5 11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11H5ZM7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7H7ZM2 13.5036C2 13.4568 2 13.1099 2 12.8362C2 12.8067 2 12.612 2 12.571C2 12.545 2 12.3094 2 12.273C2 12.2606 2 12.1274 2 12.1126C2 12.1067 2 12.0363 2 12.0298C2 12.0242 2 11.9513 2 11.9452C2 11.9357 2 11.7828 2 11.7712C2 11.7668 2 11.6867 2 11.6818C2 11.6778 2 11.5954 2 11.5909C2 11.5846 2 11.4131 2 11.4049C2 11.4021 2 11.313 2 11.3098C2 11.3074 2 11.2162 2 11.2134C2 11.2102 2 11.0218 2 11.0169C2 11.0152 2 10.8191 2 10.8158C2 10.8153 2 10.7146 2 10.7137C2 10.7135 2 10.6625 2 10.6622C2 10.6621 2 10.6107 2 10.6105C2 10.6105 2 10.5587 2 10.5586C2 10.5499 2 10.5412 2 10.5325C2 10.5238 2 10.5151 2 10.5064C2 10.4977 2 10.489 2 10.4802C2 10.4715 2 10.4628 2 10.454C2 10.4453 2 10.4365 2 10.4277C2 10.419 2 10.4102 2 10.4014C2 10.3926 2 10.3838 2 10.375C2 10.3662 2 10.3574 2 10.3486C2 10.3397 2 10.3309 2 10.3221C2 10.3132 2 10.3044 2 10.2955C2 10.2867 2 10.2778 2 10.2689C2 10.2601 2 10.2512 2 10.2423C2 10.2334 2 10.2245 2 10.2156C2 10.2067 2 10.1978 2 10.1889C2 10.1799 2 10.171 2 10.1621C2 10.1531 2 10.1442 2 10.1352C2 10.1263 2 10.1173 2 10.1084C2 10.0994 2 10.0904 2 10.0814C2 10.0725 2 10.0635 2 10.0545C2 10.0455 2 10.0365 2 10.0275C2 10.0185 2 10.0094 2 10.0004C2 9.99139 2 9.98236 2 9.97332C2 9.96428 2 9.95524 2 9.94618C2 9.93713 2 9.92807 2 9.91901C2 9.90995 2 9.90087 2 9.8918C2 9.88272 2 9.87364 2 9.86454C2 9.85545 2 9.84636 2 9.83726C2 9.82815 2 9.81905 2 9.80993C2 9.80082 2 9.79169 2 9.78257C2 9.77344 2 9.76431 2 9.75517C2 9.74603 2 9.73689 2 9.72774C2 9.71859 2 9.70943 2 9.70027C2 9.69111 2 9.68195 2 9.67278C2 9.6636 2 9.65443 2 9.64525C2 9.63606 2 9.62688 2 9.61768C2 9.60849 2 9.59929 2 9.59009C2 9.58089 2 9.57168 2 9.56247C2 9.55326 2 9.54404 2 9.53482C2 9.5256 2 9.51637 2 9.50714C2 9.49791 2 9.48867 2 9.47943C2 9.47019 2 9.46095 2 9.4517C2 9.44245 2 9.4332 2 9.42394C2 9.41468 2 9.40542 2 9.39616C2 9.38689 2 9.37762 2 9.36835C2 9.35908 2 9.3498 2 9.34052C2 9.33124 2 9.32195 2 9.31266C2 9.30338 2 9.29408 2 9.28479C2 9.27549 2 9.26619 2 9.25689C2 9.24759 2 9.23828 2 9.22897C2 9.21966 2 9.21035 2 9.20103C2 9.19172 2 9.1824 2 9.17308C2 9.16376 2 9.15443 2 9.1451C2 9.13578 2 9.12645 2 9.11711C2 9.10778 2 9.09844 2 9.08911C2 9.07977 2 9.07043 2 9.06108C2 9.05174 2 9.04239 2 9.03304C2 9.0237 2 9.01435 2 9.00499C2 8.99564 2 8.98628 2 8.97693C2 8.96757 2 8.95821 2 8.94885C2 8.93949 2 8.93012 2 8.92076C2 8.91139 2 8.90203 2 8.89266C2 8.88329 2 8.87392 2 8.86455C2 8.85518 2 8.8458 2 8.83643C2 8.82705 2 8.81768 2 8.8083C2 8.79892 2 8.78954 2 8.78016C2 8.77078 2 8.7614 2 8.75202C2 8.74264 2 8.73325 2 8.72387C2 8.71449 2 8.7051 2 8.69571C2 8.68633 2 8.67694 2 8.66755C2 8.65817 2 8.64878 2 8.63939C2 8.63938 2 8.41405 2 8.41404C2 8.41203 2 8.19076 2 8.18889C2 8.18438 2 7.96858 2 7.96434C2 7.9568 2 7.74794 2 7.7408C2 7.72966 2 7.52928 2 7.51867C2 7.50333 2 7.31303 2 7.29835C2 7.27817 2 7.09962 2 7.08024C2 7.05455 2 6.88949 2 6.86474C2 6.79315 2 6.51024 2 6.44319C2 6.34052 2 6.13396 2 6.03691C2 5.89663 2 5.78269 2 5.64911C2 5.46417 2 5.46017 2 5.283C2 5.17231 2 5.21762 2 5.10908C2 5.07945 2 5.0961 2 5.06662C2 5.03611 2 5.05495 2 5.02458C2 4.96069 2 5.00509 2 4.94179C2 4.87416 2 4.92779 2 4.86075C2 4.78924 2 4.85242 2 4.78152C2 4.706 2 4.77904 2 4.70415C2 4.62449 2 4.70771 2 4.62869C2 4.54474 2 4.63848 2 4.55519C2 4.51164 2 4.56256 2 4.51918C2 4.47451 2 4.52819 2 4.48369C2 4.39074 2 4.5065 2 4.41425C2 4.31659 2 4.44387 2 4.34692C2 4.29637 2 4.36444 2 4.31406C2 4.26228 2 4.33335 2 4.28175C2 4.22871 2 4.30284 2 4.24999C2 4.24474 2 4.23952 2 4.23432C2 4.22912 2 4.22394 2 4.21879C2 4.16319 2 4.24356 2 4.18815C2 4.18309 2 4.17806 2 4.17305C2 4.16803 2 4.16305 2 4.15808C2 4.09985 2 4.18663 2 4.1286C2 4.06902 2 4.15907 2 4.09969C2 4.03875 2 4.13212 2 4.07137C2 4.00905 2 4.10578 2 4.04365C2 3.97993 2 4.08006 2 4.01654C2 3.95139 2 4.05498 2 3.99003C2 3.92343 2 4.03053 2 3.96414C2 3.95987 2 3.95563 2 3.95142C2 3.94721 2 3.94302 2 3.93886C2 3.86932 2 3.98355 2 3.91422C2 3.84317 2 3.96104 2 3.89021C2 3.81764 2 3.93919 2 3.86684C2 3.79272 2 3.91801 2 3.84411C2 3.84038 2 3.83667 2 3.83299C2 3.82931 2 3.82566 2 3.82204C2 3.74477 2 3.87768 2 3.80063C2 3.72175 2 3.85853 2 3.77988C2 3.69937 2 3.84008 2 3.7598C2 3.67765 2 3.82233 2 3.7404C2 3.65657 2 3.80528 2 3.72169C2 3.71862 2 3.71559 2 3.71259C2 3.70958 2 3.70661 2 3.70366C2 3.70072 2 3.6978 2 3.69491C2 3.69202 2 3.68916 2 3.68633C2 3.6835 2 3.6807 2 3.67793C2 3.67516 2 3.67242 2 3.66971C2 3.66699 2 3.66431 2 3.66166C2 3.65901 2 3.65638 2 3.65379C2 3.6512 2 3.64863 2 3.6461C2 3.64357 2 3.64106 2 3.63859C2 3.63611 2 3.63367 2 3.63126C2 3.62884 2 3.62646 2 3.62411C2 3.62176 2 3.61943 2 3.61714C2 3.61485 2 3.61259 2 3.61036C2 3.60812 2 3.60592 2 3.60375C2 3.60158 2 3.59945 2 3.59734C2 3.59523 2 3.59315 2 3.59111C2 3.58906 2 3.58704 2 3.58506C2 3.58308 2 3.58112 2 3.5792C2 3.57728 2 3.57539 2 3.57353C2 3.57167 2 3.56984 2 3.56805C2 3.56625 2 3.56448 2 3.56275C2 3.56102 2 3.55932 2 3.55765C2 3.55598 2 3.55434 2 3.55273C2 3.55113 2 3.54955 2 3.54801C2 3.54647 2 3.54496 2 3.54348C2 3.542 2 3.54055 2 3.53914C2 3.53773 2 3.53635 2 3.535C2 3.53365 2 3.53233 2 3.53105C2 3.52976 2 3.52851 2 3.52729C2 3.52607 2 3.52489 2 3.52373C2 3.52258 2 3.52146 2 3.52037C2 3.51929 2 3.51823 2 3.51721C2 3.51619 2 3.5152 2 3.51424C2 3.51329 2 3.51237 2 3.51148C2 3.51059 2 3.50973 2 3.50891C2 3.50809 2 3.5073 2 3.50655C2 3.50579 2 3.50507 2 3.50438C2 3.5037 2 3.50304 2 3.50242C2 3.5018 2 3.50122 2 3.50066C2 3.50011 2 3.49959 2 3.49911C2 3.49863 2 3.49818 2 3.49776C2 3.49734 2 3.49696 2 3.49662C2 3.49627 2 3.49596 2 3.49568C2 3.4954 2 3.49516 2 3.49495C2 3.49474 2 3.49456 2 3.49442C2 3.49428 2 3.49418 2 3.49411C2 3.49404 2 3.494 1 3.494C0 3.494 0 3.49404 0 3.49411C0 3.49418 0 3.49428 0 3.49442C0 3.49456 0 3.49474 0 3.49495C0 3.49516 0 3.4954 0 3.49568C0 3.49596 0 3.49627 0 3.49662C0 3.49696 0 3.49734 0 3.49776C0 3.49818 0 3.49863 0 3.49911C0 3.49959 0 3.50011 0 3.50066C0 3.50122 0 3.5018 0 3.50242C0 3.50304 0 3.5037 0 3.50438C0 3.50507 0 3.50579 0 3.50655C0 3.5073 0 3.50809 0 3.50891C0 3.50973 0 3.51059 0 3.51148C0 3.51237 0 3.51329 0 3.51424C0 3.5152 0 3.51619 0 3.51721C0 3.51823 0 3.51929 0 3.52037C0 3.52146 0 3.52258 0 3.52373C0 3.52489 0 3.52607 0 3.52729C0 3.52851 0 3.52976 0 3.53105C0 3.53233 0 3.53365 0 3.535C0 3.53635 0 3.53773 0 3.53914C0 3.54055 0 3.542 0 3.54348C0 3.54496 0 3.54647 0 3.54801C0 3.54955 0 3.55113 0 3.55273C0 3.55434 0 3.55598 0 3.55765C0 3.55932 0 3.56102 0 3.56275C0 3.56448 0 3.56625 0 3.56805C0 3.56984 0 3.57167 0 3.57353C0 3.57539 0 3.57728 0 3.5792C0 3.58112 0 3.58308 0 3.58506C0 3.58704 0 3.58906 0 3.59111C0 3.59315 0 3.59523 0 3.59734C0 3.59945 0 3.60158 0 3.60375C0 3.60592 0 3.60812 0 3.61036C0 3.61259 0 3.61485 0 3.61714C0 3.61943 0 3.62176 0 3.62411C0 3.62646 0 3.62884 0 3.63126C0 3.63367 0 3.63611 0 3.63859C0 3.64106 0 3.64357 0 3.6461C0 3.64863 0 3.6512 0 3.65379C0 3.65638 0 3.65901 0 3.66166C0 3.66431 0 3.66699 0 3.66971C0 3.67242 0 3.67516 0 3.67793C0 3.6807 0 3.6835 0 3.68633C0 3.68916 0 3.69202 0 3.69491C0 3.6978 0 3.70072 0 3.70366C0 3.70661 0 3.70958 0 3.71259C0 3.71559 0 3.71862 0 3.72169C0 3.80528 0 3.65657 0 3.7404C0 3.82233 0 3.67765 0 3.7598C0 3.84008 0 3.69937 0 3.77988C0 3.85853 0 3.72175 0 3.80063C0 3.87768 0 3.74477 0 3.82204C0 3.82566 0 3.82931 0 3.83299C0 3.83667 0 3.84038 0 3.84411C0 3.91801 0 3.79272 0 3.86684C0 3.93919 0 3.81764 0 3.89021C0 3.96104 0 3.84317 0 3.91422C0 3.98355 0 3.86932 0 3.93886C0 3.94302 0 3.94721 0 3.95142C0 3.95563 0 3.95987 0 3.96414C0 4.03053 0 3.92343 0 3.99003C0 4.05498 0 3.95139 0 4.01654C0 4.08006 0 3.97993 0 4.04365C0 4.10578 0 4.00905 0 4.07137C0 4.13212 0 4.03875 0 4.09969C0 4.15907 0 4.06902 0 4.1286C0 4.18663 0 4.09985 0 4.15808C0 4.16305 0 4.16803 0 4.17305C0 4.17806 0 4.18309 0 4.18815C0 4.24356 0 4.16319 0 4.21879C0 4.22394 0 4.22912 0 4.23432C0 4.23952 0 4.24474 0 4.24999C0 4.30284 0 4.22871 0 4.28175C0 4.33335 0 4.26228 0 4.31406C0 4.36444 0 4.29637 0 4.34692C0 4.44387 0 4.31659 0 4.41425C0 4.5065 0 4.39074 0 4.48369C0 4.52819 0 4.47451 0 4.51918C0 4.56256 0 4.51164 0 4.55519C0 4.63848 0 4.54474 0 4.62869C0 4.70771 0 4.62449 0 4.70415C0 4.77904 0 4.706 0 4.78152C0 4.85242 0 4.78924 0 4.86075C0 4.92779 0 4.87416 0 4.94179C0 5.00509 0 4.96069 0 5.02458C0 5.05495 0 5.03611 0 5.06662C0 5.0961 0 5.07945 0 5.10908C0 5.21762 0 5.17231 0 5.283C0 5.46017 0 5.46417 0 5.64911C0 5.78269 0 5.89663 0 6.03691C0 6.13396 0 6.34052 0 6.44319C0 6.51024 0 6.79315 0 6.86474C0 6.88949 0 7.05455 0 7.08024C0 7.09962 0 7.27817 0 7.29835C0 7.31303 0 7.50333 0 7.51867C0 7.52928 0 7.72966 0 7.7408C0 7.74794 0 7.9568 0 7.96434C0 7.96858 0 8.18438 0 8.18889C0 8.19076 0 8.41203 0 8.41404C0 8.41405 0 8.63938 0 8.63939C0 8.64878 0 8.65817 0 8.66755C0 8.67694 0 8.68633 0 8.69571C0 8.7051 0 8.71449 0 8.72387C0 8.73325 0 8.74264 0 8.75202C0 8.7614 0 8.77078 0 8.78016C0 8.78954 0 8.79892 0 8.8083C0 8.81768 0 8.82705 0 8.83643C0 8.8458 0 8.85518 0 8.86455C0 8.87392 0 8.88329 0 8.89266C0 8.90203 0 8.91139 0 8.92076C0 8.93012 0 8.93949 0 8.94885C0 8.95821 0 8.96757 0 8.97693C0 8.98628 0 8.99564 0 9.00499C0 9.01435 0 9.0237 0 9.03304C0 9.04239 0 9.05174 0 9.06108C0 9.07043 0 9.07977 0 9.08911C0 9.09844 0 9.10778 0 9.11711C0 9.12645 0 9.13578 0 9.1451C0 9.15443 0 9.16376 0 9.17308C0 9.1824 0 9.19172 0 9.20103C0 9.21035 0 9.21966 0 9.22897C0 9.23828 0 9.24759 0 9.25689C0 9.26619 0 9.27549 0 9.28479C0 9.29408 0 9.30338 0 9.31266C0 9.32195 0 9.33124 0 9.34052C0 9.3498 0 9.35908 0 9.36835C0 9.37762 0 9.38689 0 9.39616C0 9.40542 0 9.41468 0 9.42394C0 9.4332 0 9.44245 0 9.4517C0 9.46095 0 9.47019 0 9.47943C0 9.48867 0 9.49791 0 9.50714C0 9.51637 0 9.5256 0 9.53482C0 9.54404 0 9.55326 0 9.56247C0 9.57168 0 9.58089 0 9.59009C0 9.59929 0 9.60849 0 9.61768C0 9.62688 0 9.63606 0 9.64525C0 9.65443 0 9.6636 0 9.67278C0 9.68195 0 9.69111 0 9.70027C0 9.70943 0 9.71859 0 9.72774C0 9.73689 0 9.74603 0 9.75517C0 9.76431 0 9.77344 0 9.78257C0 9.79169 0 9.80082 0 9.80993C0 9.81905 0 9.82815 0 9.83726C0 9.84636 0 9.85545 0 9.86454C0 9.87364 0 9.88272 0 9.8918C0 9.90087 0 9.90995 0 9.91901C0 9.92807 0 9.93713 0 9.94618C0 9.95524 0 9.96428 0 9.97332C0 9.98236 0 9.99139 0 10.0004C0 10.0094 0 10.0185 0 10.0275C0 10.0365 0 10.0455 0 10.0545C0 10.0635 0 10.0725 0 10.0814C0 10.0904 0 10.0994 0 10.1084C0 10.1173 0 10.1263 0 10.1352C0 10.1442 0 10.1531 0 10.1621C0 10.171 0 10.1799 0 10.1889C0 10.1978 0 10.2067 0 10.2156C0 10.2245 0 10.2334 0 10.2423C0 10.2512 0 10.2601 0 10.2689C0 10.2778 0 10.2867 0 10.2955C0 10.3044 0 10.3132 0 10.3221C0 10.3309 0 10.3397 0 10.3486C0 10.3574 0 10.3662 0 10.375C0 10.3838 0 10.3926 0 10.4014C0 10.4102 0 10.419 0 10.4277C0 10.4365 0 10.4453 0 10.454C0 10.4628 0 10.4715 0 10.4802C0 10.489 0 10.4977 0 10.5064C0 10.5151 0 10.5238 0 10.5325C0 10.5412 0 10.5499 0 10.5586C0 10.5587 0 10.6105 0 10.6105C0 10.6107 0 10.6621 0 10.6622C0 10.6625 0 10.7135 0 10.7137C0 10.7146 0 10.8153 0 10.8158C0 10.8191 0 11.0152 0 11.0169C0 11.0218 0 11.2102 0 11.2134C0 11.2162 0 11.3074 0 11.3098C0 11.313 0 11.4021 0 11.4049C0 11.4131 0 11.5846 0 11.5909C0 11.5954 0 11.6778 0 11.6818C0 11.6867 0 11.7668 0 11.7712C0 11.7828 0 11.9357 0 11.9452C0 11.9513 0 12.0242 0 12.0298C0 12.0363 0 12.1067 0 12.1126C0 12.1274 0 12.2606 0 12.273C0 12.3094 0 12.545 0 12.571C0 12.612 0 12.8067 0 12.8362C0 13.1099 0 13.4568 0 13.5036H2ZM2.5 2.9976H9.5V0.997602H2.5V2.9976ZM10 3.494V13.5036H12V3.494H10ZM9.5 14H2.5V16H9.5V14ZM10 13.5036C10 13.7755 9.77841 14 9.5 14V16C10.8784 16 12 14.8846 12 13.5036H10ZM9.5 2.9976C9.77841 2.9976 10 3.22211 10 3.494H12C12 2.11302 10.8784 0.997602 9.5 0.997602V2.9976ZM2 3.494C2 3.22211 2.22159 2.9976 2.5 2.9976V0.997602C1.12155 0.997602 0 2.11302 0 3.494H2ZM0 13.5036C0 14.8846 1.12155 16 2.5 16V14C2.22159 14 2 13.7755 2 13.5036H0ZM7 2.9952V1H5V2.9952H7ZM4 10H8V8H4V10ZM7 11V7H5V11H7Z"
          fill="#12C971"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'unmark-employee') || icon === 'unmark-employee'"
        class="c-button-icon_stroked"
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 2.9952V1M3.99231 7.04688L5.99216 9.04672M5.99216 9.04672L7.96872 11.0233M5.99216 9.04672L7.99201 7.04688M5.99216 9.04672L4.0156 11.0233M11 13.5036V3.494C11 2.66756 10.3284 1.9976 9.5 1.9976H2.5C1.67157 1.9976 1 2.66756 1 3.494C1 3.494 1 12.6772 1 13.5036C1 14.33 1.67157 15 2.5 15H9.5C10.3284 15 11 14.33 11 13.5036Z"
          stroke="#FF238D"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'employee') || icon === 'employee'"
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.03125 14.5012C8.03125 15.0535 8.47897 15.5012 9.03125 15.5012C9.58354 15.5012 10.0312 15.0535 10.0312 14.5012H8.03125ZM7.78125 12.0072V11.0072V12.0072ZM3.01562 13.3373H2.01562H3.01562ZM2.01562 14.5012C2.01562 15.0535 2.46334 15.5012 3.01562 15.5012C3.56791 15.5012 4.01562 15.0535 4.01562 14.5012H2.01562ZM1 3.494H0H1ZM5 2.9952C5 3.54749 5.44772 3.9952 6 3.9952C6.55228 3.9952 7 3.54749 7 2.9952H5ZM7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1H7ZM10.0312 14.5012V13.3373H8.03125V14.5012H10.0312ZM10.0312 13.3373C10.0312 12.7387 9.80835 12.153 9.39385 11.712L7.93642 13.0816C7.99076 13.1394 8.03125 13.2304 8.03125 13.3373H10.0312ZM9.39385 11.712C8.97737 11.2688 8.39874 11.0072 7.78125 11.0072V13.0072C7.8268 13.0072 7.88405 13.0259 7.93642 13.0816L9.39385 11.712ZM7.78125 11.0072H4.26562V13.0072H7.78125V11.0072ZM4.26562 11.0072C3.64813 11.0072 3.0695 11.2688 2.65302 11.712L4.11046 13.0816C4.16282 13.0259 4.22008 13.0072 4.26562 13.0072V11.0072ZM2.65302 11.712C2.23853 12.153 2.01562 12.7387 2.01562 13.3373H4.01562C4.01562 13.2304 4.05612 13.1394 4.11046 13.0816L2.65302 11.712ZM2.01562 13.3373V14.5012H4.01562V13.3373H2.01562ZM6 7.98561C6 7.98659 5.99992 7.98652 6.00008 7.98572C6.00023 7.98499 6.00047 7.98423 6.00075 7.98358C6.00124 7.9824 6.00147 7.98245 6.00085 7.98307C6.00023 7.98369 5.99993 7.98371 6.00049 7.98348C6.00083 7.98333 6.00122 7.98321 6.00152 7.98315C6.00188 7.98308 6.00148 7.98321 6 7.98321V9.98321C7.1023 9.98321 8 9.09112 8 7.98561H6ZM6 7.98321C5.99852 7.98321 5.99812 7.98308 5.99848 7.98315C5.99878 7.98321 5.99917 7.98333 5.99951 7.98348C6.00007 7.98371 5.99977 7.98369 5.99915 7.98307C5.99853 7.98245 5.99876 7.9824 5.99925 7.98358C5.99953 7.98423 5.99977 7.98499 5.99992 7.98573C6.00008 7.98652 6 7.98659 6 7.98561H4C4 9.09112 4.8977 9.98321 6 9.98321V7.98321ZM6 7.98561C6 7.98463 6.00008 7.9847 5.99992 7.9855C5.99977 7.98623 5.99953 7.987 5.99925 7.98765C5.99876 7.98882 5.99853 7.98877 5.99915 7.98816C5.99977 7.98754 6.00007 7.98751 5.99951 7.98775C5.99917 7.98789 5.99878 7.98801 5.99848 7.98807C5.99812 7.98814 5.99852 7.98801 6 7.98801V5.98801C4.8977 5.98801 4 6.8801 4 7.98561H6ZM6 7.98801C6.00148 7.98801 6.00188 7.98814 6.00152 7.98807C6.00122 7.98801 6.00083 7.98789 6.00049 7.98775C5.99993 7.98751 6.00023 7.98754 6.00085 7.98816C6.00147 7.98877 6.00124 7.98882 6.00075 7.98765C6.00047 7.987 6.00023 7.98623 6.00008 7.9855C5.99992 7.9847 6 7.98463 6 7.98561H8C8 6.8801 7.1023 5.98801 6 5.98801V7.98801ZM2 13.5036C2 13.4568 2 13.1099 2 12.8362C2 12.8067 2 12.612 2 12.571C2 12.545 2 12.3094 2 12.273C2 12.2606 2 12.1274 2 12.1126C2 12.1067 2 12.0363 2 12.0298C2 12.0242 2 11.9513 2 11.9452C2 11.9357 2 11.7828 2 11.7712C2 11.7668 2 11.6867 2 11.6818C2 11.6778 2 11.5954 2 11.5909C2 11.5846 2 11.4131 2 11.4049C2 11.4021 2 11.313 2 11.3098C2 11.3074 2 11.2162 2 11.2134C2 11.2102 2 11.0218 2 11.0169C2 11.0152 2 10.8191 2 10.8158C2 10.8153 2 10.7146 2 10.7137C2 10.7135 2 10.6625 2 10.6622C2 10.6621 2 10.6107 2 10.6105C2 10.6105 2 10.5587 2 10.5586C2 10.5499 2 10.5412 2 10.5325C2 10.5238 2 10.5151 2 10.5064C2 10.4977 2 10.489 2 10.4802C2 10.4715 2 10.4628 2 10.454C2 10.4453 2 10.4365 2 10.4277C2 10.419 2 10.4102 2 10.4014C2 10.3926 2 10.3838 2 10.375C2 10.3662 2 10.3574 2 10.3486C2 10.3397 2 10.3309 2 10.3221C2 10.3132 2 10.3044 2 10.2955C2 10.2867 2 10.2778 2 10.2689C2 10.2601 2 10.2512 2 10.2423C2 10.2334 2 10.2245 2 10.2156C2 10.2067 2 10.1978 2 10.1889C2 10.1799 2 10.171 2 10.1621C2 10.1531 2 10.1442 2 10.1352C2 10.1263 2 10.1173 2 10.1084C2 10.0994 2 10.0904 2 10.0814C2 10.0725 2 10.0635 2 10.0545C2 10.0455 2 10.0365 2 10.0275C2 10.0185 2 10.0094 2 10.0004C2 9.99139 2 9.98236 2 9.97332C2 9.96428 2 9.95524 2 9.94618C2 9.93713 2 9.92807 2 9.91901C2 9.90995 2 9.90087 2 9.8918C2 9.88272 2 9.87364 2 9.86454C2 9.85545 2 9.84636 2 9.83726C2 9.82815 2 9.81905 2 9.80993C2 9.80082 2 9.79169 2 9.78257C2 9.77344 2 9.76431 2 9.75517C2 9.74603 2 9.73689 2 9.72774C2 9.71859 2 9.70943 2 9.70027C2 9.69111 2 9.68195 2 9.67278C2 9.6636 2 9.65443 2 9.64525C2 9.63606 2 9.62688 2 9.61768C2 9.60849 2 9.59929 2 9.59009C2 9.58089 2 9.57168 2 9.56247C2 9.55326 2 9.54404 2 9.53482C2 9.5256 2 9.51637 2 9.50714C2 9.49791 2 9.48867 2 9.47943C2 9.47019 2 9.46095 2 9.4517C2 9.44245 2 9.4332 2 9.42394C2 9.41468 2 9.40542 2 9.39616C2 9.38689 2 9.37762 2 9.36835C2 9.35908 2 9.3498 2 9.34052C2 9.33124 2 9.32195 2 9.31266C2 9.30338 2 9.29408 2 9.28479C2 9.27549 2 9.26619 2 9.25689C2 9.24759 2 9.23828 2 9.22897C2 9.21966 2 9.21035 2 9.20103C2 9.19172 2 9.1824 2 9.17308C2 9.16376 2 9.15443 2 9.1451C2 9.13578 2 9.12645 2 9.11711C2 9.10778 2 9.09844 2 9.08911C2 9.07977 2 9.07043 2 9.06108C2 9.05174 2 9.04239 2 9.03304C2 9.0237 2 9.01435 2 9.00499C2 8.99564 2 8.98628 2 8.97693C2 8.96757 2 8.95821 2 8.94885C2 8.93949 2 8.93012 2 8.92076C2 8.91139 2 8.90203 2 8.89266C2 8.88329 2 8.87392 2 8.86455C2 8.85518 2 8.8458 2 8.83643C2 8.82705 2 8.81768 2 8.8083C2 8.79892 2 8.78954 2 8.78016C2 8.77078 2 8.7614 2 8.75202C2 8.74264 2 8.73325 2 8.72387C2 8.71449 2 8.7051 2 8.69571C2 8.68633 2 8.67694 2 8.66755C2 8.65817 2 8.64878 2 8.63939C2 8.63938 2 8.41405 2 8.41404C2 8.41203 2 8.19076 2 8.18889C2 8.18438 2 7.96858 2 7.96434C2 7.9568 2 7.74794 2 7.7408C2 7.72966 2 7.52928 2 7.51867C2 7.50333 2 7.31303 2 7.29835C2 7.27817 2 7.09962 2 7.08024C2 7.05455 2 6.88949 2 6.86474C2 6.79315 2 6.51024 2 6.44319C2 6.34052 2 6.13396 2 6.03691C2 5.89663 2 5.78269 2 5.64911C2 5.46417 2 5.46017 2 5.283C2 5.17231 2 5.21762 2 5.10908C2 5.07945 2 5.0961 2 5.06662C2 5.03611 2 5.05495 2 5.02458C2 4.96069 2 5.00509 2 4.94179C2 4.87416 2 4.92779 2 4.86075C2 4.78924 2 4.85242 2 4.78152C2 4.706 2 4.77904 2 4.70415C2 4.62449 2 4.70771 2 4.62869C2 4.54474 2 4.63848 2 4.55519C2 4.51164 2 4.56256 2 4.51918C2 4.47451 2 4.52819 2 4.48369C2 4.39074 2 4.5065 2 4.41425C2 4.31659 2 4.44387 2 4.34692C2 4.29637 2 4.36444 2 4.31406C2 4.26228 2 4.33335 2 4.28175C2 4.22871 2 4.30284 2 4.24999C2 4.24474 2 4.23952 2 4.23432C2 4.22912 2 4.22394 2 4.21879C2 4.16319 2 4.24356 2 4.18815C2 4.18309 2 4.17806 2 4.17305C2 4.16803 2 4.16305 2 4.15808C2 4.09985 2 4.18663 2 4.1286C2 4.06902 2 4.15907 2 4.09969C2 4.03875 2 4.13212 2 4.07137C2 4.00905 2 4.10578 2 4.04365C2 3.97993 2 4.08006 2 4.01654C2 3.95139 2 4.05498 2 3.99003C2 3.92343 2 4.03053 2 3.96414C2 3.95987 2 3.95563 2 3.95142C2 3.94721 2 3.94302 2 3.93886C2 3.86932 2 3.98355 2 3.91422C2 3.84317 2 3.96104 2 3.89021C2 3.81764 2 3.93919 2 3.86684C2 3.79272 2 3.91801 2 3.84411C2 3.84038 2 3.83667 2 3.83299C2 3.82931 2 3.82566 2 3.82204C2 3.74477 2 3.87768 2 3.80063C2 3.72175 2 3.85853 2 3.77988C2 3.69937 2 3.84008 2 3.7598C2 3.67765 2 3.82233 2 3.7404C2 3.65657 2 3.80528 2 3.72169C2 3.71862 2 3.71559 2 3.71259C2 3.70958 2 3.70661 2 3.70366C2 3.70072 2 3.6978 2 3.69491C2 3.69202 2 3.68916 2 3.68633C2 3.6835 2 3.6807 2 3.67793C2 3.67516 2 3.67242 2 3.66971C2 3.66699 2 3.66431 2 3.66166C2 3.65901 2 3.65638 2 3.65379C2 3.6512 2 3.64863 2 3.6461C2 3.64357 2 3.64106 2 3.63859C2 3.63611 2 3.63367 2 3.63126C2 3.62884 2 3.62646 2 3.62411C2 3.62176 2 3.61943 2 3.61714C2 3.61485 2 3.61259 2 3.61036C2 3.60812 2 3.60592 2 3.60375C2 3.60158 2 3.59945 2 3.59734C2 3.59523 2 3.59315 2 3.59111C2 3.58906 2 3.58704 2 3.58506C2 3.58308 2 3.58112 2 3.5792C2 3.57728 2 3.57539 2 3.57353C2 3.57167 2 3.56984 2 3.56805C2 3.56625 2 3.56448 2 3.56275C2 3.56102 2 3.55932 2 3.55765C2 3.55598 2 3.55434 2 3.55273C2 3.55113 2 3.54955 2 3.54801C2 3.54647 2 3.54496 2 3.54348C2 3.542 2 3.54055 2 3.53914C2 3.53773 2 3.53635 2 3.535C2 3.53365 2 3.53233 2 3.53105C2 3.52976 2 3.52851 2 3.52729C2 3.52607 2 3.52489 2 3.52373C2 3.52258 2 3.52146 2 3.52037C2 3.51929 2 3.51823 2 3.51721C2 3.51619 2 3.5152 2 3.51424C2 3.51329 2 3.51237 2 3.51148C2 3.51059 2 3.50973 2 3.50891C2 3.50809 2 3.5073 2 3.50655C2 3.50579 2 3.50507 2 3.50438C2 3.5037 2 3.50304 2 3.50242C2 3.5018 2 3.50122 2 3.50066C2 3.50011 2 3.49959 2 3.49911C2 3.49863 2 3.49818 2 3.49776C2 3.49734 2 3.49696 2 3.49662C2 3.49627 2 3.49596 2 3.49568C2 3.4954 2 3.49516 2 3.49495C2 3.49474 2 3.49456 2 3.49442C2 3.49428 2 3.49418 2 3.49411C2 3.49404 2 3.494 1 3.494C0 3.494 0 3.49404 0 3.49411C0 3.49418 0 3.49428 0 3.49442C0 3.49456 0 3.49474 0 3.49495C0 3.49516 0 3.4954 0 3.49568C0 3.49596 0 3.49627 0 3.49662C0 3.49696 0 3.49734 0 3.49776C0 3.49818 0 3.49863 0 3.49911C0 3.49959 0 3.50011 0 3.50066C0 3.50122 0 3.5018 0 3.50242C0 3.50304 0 3.5037 0 3.50438C0 3.50507 0 3.50579 0 3.50655C0 3.5073 0 3.50809 0 3.50891C0 3.50973 0 3.51059 0 3.51148C0 3.51237 0 3.51329 0 3.51424C0 3.5152 0 3.51619 0 3.51721C0 3.51823 0 3.51929 0 3.52037C0 3.52146 0 3.52258 0 3.52373C0 3.52489 0 3.52607 0 3.52729C0 3.52851 0 3.52976 0 3.53105C0 3.53233 0 3.53365 0 3.535C0 3.53635 0 3.53773 0 3.53914C0 3.54055 0 3.542 0 3.54348C0 3.54496 0 3.54647 0 3.54801C0 3.54955 0 3.55113 0 3.55273C0 3.55434 0 3.55598 0 3.55765C0 3.55932 0 3.56102 0 3.56275C0 3.56448 0 3.56625 0 3.56805C0 3.56984 0 3.57167 0 3.57353C0 3.57539 0 3.57728 0 3.5792C0 3.58112 0 3.58308 0 3.58506C0 3.58704 0 3.58906 0 3.59111C0 3.59315 0 3.59523 0 3.59734C0 3.59945 0 3.60158 0 3.60375C0 3.60592 0 3.60812 0 3.61036C0 3.61259 0 3.61485 0 3.61714C0 3.61943 0 3.62176 0 3.62411C0 3.62646 0 3.62884 0 3.63126C0 3.63367 0 3.63611 0 3.63859C0 3.64106 0 3.64357 0 3.6461C0 3.64863 0 3.6512 0 3.65379C0 3.65638 0 3.65901 0 3.66166C0 3.66431 0 3.66699 0 3.66971C0 3.67242 0 3.67516 0 3.67793C0 3.6807 0 3.6835 0 3.68633C0 3.68916 0 3.69202 0 3.69491C0 3.6978 0 3.70072 0 3.70366C0 3.70661 0 3.70958 0 3.71259C0 3.71559 0 3.71862 0 3.72169C0 3.80528 0 3.65657 0 3.7404C0 3.82233 0 3.67765 0 3.7598C0 3.84008 0 3.69937 0 3.77988C0 3.85853 0 3.72175 0 3.80063C0 3.87768 0 3.74477 0 3.82204C0 3.82566 0 3.82931 0 3.83299C0 3.83667 0 3.84038 0 3.84411C0 3.91801 0 3.79272 0 3.86684C0 3.93919 0 3.81764 0 3.89021C0 3.96104 0 3.84317 0 3.91422C0 3.98355 0 3.86932 0 3.93886C0 3.94302 0 3.94721 0 3.95142C0 3.95563 0 3.95987 0 3.96414C0 4.03053 0 3.92343 0 3.99003C0 4.05498 0 3.95139 0 4.01654C0 4.08006 0 3.97993 0 4.04365C0 4.10578 0 4.00905 0 4.07137C0 4.13212 0 4.03875 0 4.09969C0 4.15907 0 4.06902 0 4.1286C0 4.18663 0 4.09985 0 4.15808C0 4.16305 0 4.16803 0 4.17305C0 4.17806 0 4.18309 0 4.18815C0 4.24356 0 4.16319 0 4.21879C0 4.22394 0 4.22912 0 4.23432C0 4.23952 0 4.24474 0 4.24999C0 4.30284 0 4.22871 0 4.28175C0 4.33335 0 4.26228 0 4.31406C0 4.36444 0 4.29637 0 4.34692C0 4.44387 0 4.31659 0 4.41425C0 4.5065 0 4.39074 0 4.48369C0 4.52819 0 4.47451 0 4.51918C0 4.56256 0 4.51164 0 4.55519C0 4.63848 0 4.54474 0 4.62869C0 4.70771 0 4.62449 0 4.70415C0 4.77904 0 4.706 0 4.78152C0 4.85242 0 4.78924 0 4.86075C0 4.92779 0 4.87416 0 4.94179C0 5.00509 0 4.96069 0 5.02458C0 5.05495 0 5.03611 0 5.06662C0 5.0961 0 5.07945 0 5.10908C0 5.21762 0 5.17231 0 5.283C0 5.46017 0 5.46417 0 5.64911C0 5.78269 0 5.89663 0 6.03691C0 6.13396 0 6.34052 0 6.44319C0 6.51024 0 6.79315 0 6.86474C0 6.88949 0 7.05455 0 7.08024C0 7.09962 0 7.27817 0 7.29835C0 7.31303 0 7.50333 0 7.51867C0 7.52928 0 7.72966 0 7.7408C0 7.74794 0 7.9568 0 7.96434C0 7.96858 0 8.18438 0 8.18889C0 8.19076 0 8.41203 0 8.41404C0 8.41405 0 8.63938 0 8.63939C0 8.64878 0 8.65817 0 8.66755C0 8.67694 0 8.68633 0 8.69571C0 8.7051 0 8.71449 0 8.72387C0 8.73325 0 8.74264 0 8.75202C0 8.7614 0 8.77078 0 8.78016C0 8.78954 0 8.79892 0 8.8083C0 8.81768 0 8.82705 0 8.83643C0 8.8458 0 8.85518 0 8.86455C0 8.87392 0 8.88329 0 8.89266C0 8.90203 0 8.91139 0 8.92076C0 8.93012 0 8.93949 0 8.94885C0 8.95821 0 8.96757 0 8.97693C0 8.98628 0 8.99564 0 9.00499C0 9.01435 0 9.0237 0 9.03304C0 9.04239 0 9.05174 0 9.06108C0 9.07043 0 9.07977 0 9.08911C0 9.09844 0 9.10778 0 9.11711C0 9.12645 0 9.13578 0 9.1451C0 9.15443 0 9.16376 0 9.17308C0 9.1824 0 9.19172 0 9.20103C0 9.21035 0 9.21966 0 9.22897C0 9.23828 0 9.24759 0 9.25689C0 9.26619 0 9.27549 0 9.28479C0 9.29408 0 9.30338 0 9.31266C0 9.32195 0 9.33124 0 9.34052C0 9.3498 0 9.35908 0 9.36835C0 9.37762 0 9.38689 0 9.39616C0 9.40542 0 9.41468 0 9.42394C0 9.4332 0 9.44245 0 9.4517C0 9.46095 0 9.47019 0 9.47943C0 9.48867 0 9.49791 0 9.50714C0 9.51637 0 9.5256 0 9.53482C0 9.54404 0 9.55326 0 9.56247C0 9.57168 0 9.58089 0 9.59009C0 9.59929 0 9.60849 0 9.61768C0 9.62688 0 9.63606 0 9.64525C0 9.65443 0 9.6636 0 9.67278C0 9.68195 0 9.69111 0 9.70027C0 9.70943 0 9.71859 0 9.72774C0 9.73689 0 9.74603 0 9.75517C0 9.76431 0 9.77344 0 9.78257C0 9.79169 0 9.80082 0 9.80993C0 9.81905 0 9.82815 0 9.83726C0 9.84636 0 9.85545 0 9.86454C0 9.87364 0 9.88272 0 9.8918C0 9.90087 0 9.90995 0 9.91901C0 9.92807 0 9.93713 0 9.94618C0 9.95524 0 9.96428 0 9.97332C0 9.98236 0 9.99139 0 10.0004C0 10.0094 0 10.0185 0 10.0275C0 10.0365 0 10.0455 0 10.0545C0 10.0635 0 10.0725 0 10.0814C0 10.0904 0 10.0994 0 10.1084C0 10.1173 0 10.1263 0 10.1352C0 10.1442 0 10.1531 0 10.1621C0 10.171 0 10.1799 0 10.1889C0 10.1978 0 10.2067 0 10.2156C0 10.2245 0 10.2334 0 10.2423C0 10.2512 0 10.2601 0 10.2689C0 10.2778 0 10.2867 0 10.2955C0 10.3044 0 10.3132 0 10.3221C0 10.3309 0 10.3397 0 10.3486C0 10.3574 0 10.3662 0 10.375C0 10.3838 0 10.3926 0 10.4014C0 10.4102 0 10.419 0 10.4277C0 10.4365 0 10.4453 0 10.454C0 10.4628 0 10.4715 0 10.4802C0 10.489 0 10.4977 0 10.5064C0 10.5151 0 10.5238 0 10.5325C0 10.5412 0 10.5499 0 10.5586C0 10.5587 0 10.6105 0 10.6105C0 10.6107 0 10.6621 0 10.6622C0 10.6625 0 10.7135 0 10.7137C0 10.7146 0 10.8153 0 10.8158C0 10.8191 0 11.0152 0 11.0169C0 11.0218 0 11.2102 0 11.2134C0 11.2162 0 11.3074 0 11.3098C0 11.313 0 11.4021 0 11.4049C0 11.4131 0 11.5846 0 11.5909C0 11.5954 0 11.6778 0 11.6818C0 11.6867 0 11.7668 0 11.7712C0 11.7828 0 11.9357 0 11.9452C0 11.9513 0 12.0242 0 12.0298C0 12.0363 0 12.1067 0 12.1126C0 12.1274 0 12.2606 0 12.273C0 12.3094 0 12.545 0 12.571C0 12.612 0 12.8067 0 12.8362C0 13.1099 0 13.4568 0 13.5036H2ZM2.5 2.9976H9.5V0.997602H2.5V2.9976ZM10 3.494V13.5036H12V3.494H10ZM9.5 14H2.5V16H9.5V14ZM10 13.5036C10 13.7755 9.77841 14 9.5 14V16C10.8784 16 12 14.8846 12 13.5036H10ZM9.5 2.9976C9.77841 2.9976 10 3.22211 10 3.494H12C12 2.11302 10.8784 0.997602 9.5 0.997602V2.9976ZM2 3.494C2 3.22211 2.22159 2.9976 2.5 2.9976V0.997602C1.12155 0.997602 0 2.11302 0 3.494H2ZM0 13.5036C0 14.8846 1.12155 16 2.5 16V14C2.22159 14 2 13.7755 2 13.5036H0ZM7 2.9952V1H5V2.9952H7Z"
          fill="#12C971"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'expiration-date') || icon === 'expiration-date'"
        class="c-button-icon_stroked"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
          stroke="#FFB800"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'copy-to-clipboard') || icon === 'copy-to-clipboard'"
        class="c-button-icon_stroked"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 4V2C11 1.44772 10.4404 1 9.75 1H2.25C1.55964 1 1 1.44772 1 2V10C1 10.5523 1.55964 11 2.25 11H4M7 16H15C15.5523 16 16 15.5523 16 15V7C16 6.44772 15.5523 6 15 6H7C6.44772 6 6 6.44772 6 7V15C6 15.5523 6.44772 16 7 16Z"
          stroke="#8E9CBB"
          stroke-width="2"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'point') || icon === 'point'"
        class="c-button-icon_stroked"
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 7C13 11.6667 7 15.6667 7 15.6667C7 15.6667 1 11.6667 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'home') || icon === 'home'"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 13V14C13.5523 14 14 13.5523 14 13H13ZM3 13H2C2 13.5523 2.44772 14 3 14V13ZM8 1L8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L8 1ZM14.2929 8.70711C14.6834 9.09763 15.3166 9.09763 15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L14.2929 8.70711ZM0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711C0.683417 9.09763 1.31658 9.09763 1.70711 8.70711L0.292893 7.29289ZM6 8V7C5.44772 7 5 7.44772 5 8H6ZM10 8H11C11 7.44772 10.5523 7 10 7V8ZM12 6V13H14V6H12ZM13 12H3V14H13V12ZM4 13V6H2V13H4ZM7.29289 1.70711L12.2929 6.70711L13.7071 5.29289L8.70711 0.292893L7.29289 1.70711ZM12.2929 6.70711L14.2929 8.70711L15.7071 7.29289L13.7071 5.29289L12.2929 6.70711ZM7.29289 0.292893L2.29289 5.29289L3.70711 6.70711L8.70711 1.70711L7.29289 0.292893ZM2.29289 5.29289L0.292893 7.29289L1.70711 8.70711L3.70711 6.70711L2.29289 5.29289ZM7 12V8H5V12H7ZM6 9H10V7H6V9ZM9 8V12H11V8H9Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'settings') || icon === 'settings'"
        class="c-button-icon_stroked"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="#8E9CBB"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 9.90909C9.05436 9.90909 9.90909 9.05436 9.90909 8C9.90909 6.94564 9.05436 6.09091 8 6.09091C6.94564 6.09091 6.09091 6.94564 6.09091 8C6.09091 9.05436 6.94564 9.90909 8 9.90909Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7091 9.90909C12.6244 10.101 12.5991 10.3139 12.6365 10.5204C12.674 10.7268 12.7724 10.9173 12.9191 11.0673L12.9573 11.1055C13.0756 11.2237 13.1695 11.364 13.2335 11.5185C13.2976 11.673 13.3305 11.8387 13.3305 12.0059C13.3305 12.1732 13.2976 12.3388 13.2335 12.4933C13.1695 12.6478 13.0756 12.7882 12.9573 12.9064C12.8391 13.0247 12.6987 13.1186 12.5442 13.1826C12.3897 13.2467 12.2241 13.2796 12.0568 13.2796C11.8896 13.2796 11.7239 13.2467 11.5694 13.1826C11.4149 13.1186 11.2746 13.0247 11.1564 12.9064L11.1182 12.8682C10.9682 12.7215 10.7777 12.6231 10.5713 12.5856C10.3649 12.5482 10.1519 12.5735 9.96 12.6582C9.77178 12.7388 9.61126 12.8728 9.4982 13.0435C9.38513 13.2143 9.32445 13.4143 9.32364 13.6191V13.7273C9.32364 14.0648 9.18955 14.3885 8.95086 14.6272C8.71218 14.8659 8.38846 15 8.05091 15C7.71336 15 7.38964 14.8659 7.15096 14.6272C6.91227 14.3885 6.77818 14.0648 6.77818 13.7273V13.67C6.77325 13.4594 6.70508 13.2551 6.58251 13.0837C6.45994 12.9123 6.28865 12.7818 6.09091 12.7091C5.89897 12.6244 5.68606 12.5991 5.47963 12.6365C5.27319 12.674 5.0827 12.7724 4.93273 12.9191L4.89455 12.9573C4.77634 13.0756 4.63598 13.1695 4.48147 13.2335C4.32696 13.2976 4.16135 13.3305 3.99409 13.3305C3.82683 13.3305 3.66122 13.2976 3.50671 13.2335C3.35221 13.1695 3.21184 13.0756 3.09364 12.9573C2.9753 12.8391 2.88143 12.6987 2.81738 12.5442C2.75333 12.3897 2.72036 12.2241 2.72036 12.0568C2.72036 11.8896 2.75333 11.7239 2.81738 11.5694C2.88143 11.4149 2.9753 11.2746 3.09364 11.1564L3.13182 11.1182C3.27852 10.9682 3.37694 10.7777 3.41437 10.5713C3.4518 10.3649 3.42653 10.1519 3.34182 9.96C3.26115 9.77178 3.12721 9.61126 2.95648 9.4982C2.78575 9.38513 2.58568 9.32445 2.38091 9.32364H2.27273C1.93518 9.32364 1.61146 9.18955 1.37277 8.95086C1.13409 8.71218 1 8.38846 1 8.05091C1 7.71336 1.13409 7.38964 1.37277 7.15096C1.61146 6.91227 1.93518 6.77818 2.27273 6.77818H2.33C2.54063 6.77325 2.74491 6.70508 2.91628 6.58251C3.08765 6.45994 3.21818 6.28865 3.29091 6.09091C3.37562 5.89897 3.40089 5.68606 3.36346 5.47963C3.32603 5.27319 3.22761 5.0827 3.08091 4.93273L3.04273 4.89455C2.92439 4.77634 2.83052 4.63598 2.76647 4.48147C2.70242 4.32696 2.66945 4.16135 2.66945 3.99409C2.66945 3.82683 2.70242 3.66122 2.76647 3.50671C2.83052 3.35221 2.92439 3.21184 3.04273 3.09364C3.16093 2.9753 3.3013 2.88143 3.4558 2.81738C3.61031 2.75333 3.77593 2.72036 3.94318 2.72036C4.11044 2.72036 4.27605 2.75333 4.43056 2.81738C4.58507 2.88143 4.72543 2.9753 4.84364 3.09364L4.88182 3.13182C5.0318 3.27852 5.22228 3.37694 5.42872 3.41437C5.63515 3.4518 5.84806 3.42653 6.04 3.34182H6.09091C6.27913 3.26115 6.43965 3.12721 6.55271 2.95648C6.66578 2.78575 6.72646 2.58568 6.72727 2.38091V2.27273C6.72727 1.93518 6.86136 1.61146 7.10005 1.37277C7.33873 1.13409 7.66245 1 8 1C8.33755 1 8.66127 1.13409 8.89995 1.37277C9.13864 1.61146 9.27273 1.93518 9.27273 2.27273V2.33C9.27354 2.53477 9.33422 2.73484 9.44729 2.90557C9.56035 3.0763 9.72087 3.21024 9.90909 3.29091C10.101 3.37562 10.3139 3.40089 10.5204 3.36346C10.7268 3.32603 10.9173 3.22761 11.0673 3.08091L11.1055 3.04273C11.2237 2.92439 11.364 2.83052 11.5185 2.76647C11.673 2.70242 11.8387 2.66945 12.0059 2.66945C12.1732 2.66945 12.3388 2.70242 12.4933 2.76647C12.6478 2.83052 12.7882 2.92439 12.9064 3.04273C13.0247 3.16093 13.1186 3.3013 13.1826 3.4558C13.2467 3.61031 13.2796 3.77593 13.2796 3.94318C13.2796 4.11044 13.2467 4.27605 13.1826 4.43056C13.1186 4.58507 13.0247 4.72543 12.9064 4.84364L12.8682 4.88182C12.7215 5.0318 12.6231 5.22228 12.5856 5.42872C12.5482 5.63515 12.5735 5.84806 12.6582 6.04V6.09091C12.7388 6.27913 12.8728 6.43965 13.0435 6.55271C13.2143 6.66578 13.4143 6.72646 13.6191 6.72727H13.7273C14.0648 6.72727 14.3885 6.86136 14.6272 7.10005C14.8659 7.33873 15 7.66245 15 8C15 8.33755 14.8659 8.66127 14.6272 8.89995C14.3885 9.13864 14.0648 9.27273 13.7273 9.27273H13.67C13.4652 9.27354 13.2652 9.33422 13.0944 9.44729C12.9237 9.56035 12.7898 9.72087 12.7091 9.90909Z"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'fill') || icon === 'fill'"
        class="c-button-icon_stroked"
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.48523 2L13.1421 7.65685L7.48523 13.3137C6.70418 14.0948 5.43785 14.0948 4.6568 13.3137L1.82838 10.4853C1.04733 9.70423 1.04733 8.4379 1.82838 7.65685L7.48523 2Z"
          stroke="#8E9CBB"
          stroke-width="2"
        />
        <path d="M1 9L11 9L6.91307 12.6205C6.3308 13.1363 5.4159 13.1249 4.84844 12.5949L1 9Z" fill="#8E9CBB" />
        <path
          d="M17 13C17 12 15.6667 10 15 9C14.3333 10 13 12 13 13C13 14 14 15 15 15C16 15 17 14 17 13Z"
          fill="#8E9CBB"
        />
        <path d="M7 7L2 2" stroke="#8E9CBB" stroke-width="2" stroke-linecap="square" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'less') || icon === 'less'"
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.26091 6.71391C8.87039 6.32338 8.87039 5.69022 9.26091 5.29969L13.278 1.28264C13.6685 0.892115 14.3017 0.892115 14.6922 1.28264C15.0827 1.67316 15.0827 2.30633 14.6922 2.69685L10.6751 6.71391C10.2846 7.10443 9.65144 7.10443 9.26091 6.71391Z"
          fill="#8E9CBB"
        />
        <path
          d="M9.26091 5.29286C8.87039 5.68338 8.87039 6.31655 9.26091 6.70707L13.278 10.7241C13.6685 11.1146 14.3017 11.1146 14.6922 10.7241C15.0827 10.3336 15.0827 9.70044 14.6922 9.30991L10.6751 5.29286C10.2846 4.90233 9.65144 4.90233 9.26091 5.29286Z"
          fill="#8E9CBB"
        />
        <path
          d="M6.71565 6.71391C7.10618 6.32338 7.10618 5.69022 6.71565 5.29969L2.6986 1.28264C2.30807 0.892115 1.67491 0.892115 1.28438 1.28264C0.893859 1.67316 0.893859 2.30633 1.28438 2.69685L5.30144 6.71391C5.69196 7.10443 6.32513 7.10443 6.71565 6.71391Z"
          fill="#8E9CBB"
        />
        <path
          d="M6.71565 5.29286C7.10618 5.68338 7.10618 6.31655 6.71565 6.70707L2.6986 10.7241C2.30807 11.1146 1.67491 11.1146 1.28438 10.7241C0.893859 10.3336 0.893859 9.70044 1.28438 9.30991L5.30144 5.29286C5.69196 4.90233 6.32513 4.90233 6.71565 5.29286Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'more') || icon === 'more'"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.2841 6.71391C0.89358 6.32338 0.89358 5.69022 1.2841 5.29969L5.30116 1.28264C5.69168 0.892115 6.32485 0.892115 6.71537 1.28264C7.1059 1.67316 7.1059 2.30633 6.71537 2.69685L2.69832 6.71391C2.30779 7.10443 1.67463 7.10443 1.2841 6.71391Z"
          fill="#8E9CBB"
        />
        <path
          d="M1.2841 5.29286C0.89358 5.68338 0.89358 6.31655 1.2841 6.70707L5.30116 10.7241C5.69168 11.1146 6.32485 11.1146 6.71537 10.7241C7.1059 10.3336 7.1059 9.70044 6.71537 9.30991L2.69832 5.29286C2.30779 4.90233 1.67463 4.90233 1.2841 5.29286Z"
          fill="#8E9CBB"
        />
        <path
          d="M15.692 6.71391C16.0825 6.32338 16.0825 5.69022 15.692 5.29969L11.6749 1.28264C11.2844 0.892115 10.6512 0.892115 10.2607 1.28264C9.87018 1.67316 9.87018 2.30633 10.2607 2.69685L14.2778 6.71391C14.6683 7.10443 15.3014 7.10443 15.692 6.71391Z"
          fill="#8E9CBB"
        />
        <path
          d="M15.692 5.29286C16.0825 5.68338 16.0825 6.31655 15.692 6.70707L11.6749 10.7241C11.2844 11.1146 10.6512 11.1146 10.2607 10.7241C9.87018 10.3336 9.87018 9.70044 10.2607 9.30991L14.2778 5.29286C14.6683 4.90233 15.3014 4.90233 15.692 5.29286Z"
          fill="#8E9CBB"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'routes') || icon === 'routes'"
        class="c-button-icon_stroked"
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="13" cy="3" r="2" stroke="#8E9CBB" stroke-width="2" />
        <circle cx="3" cy="11" r="2" stroke="#8E9CBB" stroke-width="2" />
        <path
          d="M10.2778 3H7.17778C6.6002 3 6.04627 3.21071 5.63786 3.58579C5.22944 3.96086 5 4.46957 5 5C5 5.53043 5.22944 6.03914 5.63786 6.41421C6.04627 6.78929 6.6002 7 7.17778 7H8.82222C9.3998 7 9.95373 7.21071 10.3621 7.58579C10.7706 7.96086 11 8.46957 11 9C11 9.53043 10.7706 10.0391 10.3621 10.4142C9.95373 10.7893 9.3998 11 8.82222 11H5.93333"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="icon === 'google'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 5H13M1 9H13M7 13V1M1 1V13H13V1H1Z" stroke="#12C971" stroke-width="2" fill="white" />
      </svg>

      <svg
        v-if="icon === 'google-grey'"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 5H13M1 9H13M7 13V1M1 1V13H13V1H1Z" stroke="#dfe4ef" stroke-width="2" fill="white" />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'chevron') || icon === 'chevron'"
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.53976 0.193927C3.28126 0.45255 3.28126 0.871861 3.53976 1.13048L6.87001 4.46231C7.12851 4.72093 7.54762 4.72093 7.80612 4.46231C8.06462 4.20369 8.06462 3.78438 7.80612 3.52575L4.47587 0.193927C4.21737 -0.0646968 3.79826 -0.0646963 3.53976 0.193927Z"
          fill="#0066FF"
        />
        <path
          d="M4.47058 0.193927C4.72908 0.45255 4.72908 0.871861 4.47058 1.13048L1.12999 4.47266C0.871489 4.73128 0.452377 4.73128 0.193876 4.47266C-0.0646252 4.21404 -0.0646252 3.79472 0.193876 3.5361L3.53447 0.193927C3.79297 -0.0646968 4.21208 -0.0646963 4.47058 0.193927Z"
          fill="#0066FF"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'money') || icon === 'money'"
        width="17"
        height="13"
        viewBox="0 0 17 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 9H13M4 4H5M1 1.56935C6 -0.402927 11 3.54161 16 1.56935V11.4307C11 13.4029 6 9.45838 1 11.4307V1.56935ZM9.82353 6.57733C9.82353 7.6819 9.23097 8.57733 8.5 8.57733C7.76903 8.57733 7.17647 7.6819 7.17647 6.57733C7.17647 5.47276 7.76903 4.57733 8.5 4.57733C9.23097 4.57733 9.82353 5.47276 9.82353 6.57733Z"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-if="(icon.icon && icon.icon === 'new-line') || icon === 'new-line'"
        class="c-button-icon_stroked"
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 7.00073L4 4.00073M1 7.00073L4 10.0007M1 7.00073H10V1.00073"
          stroke="#8E9CBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg v-if="(icon.icon && icon.icon === 'fired') || icon === 'fired'" width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.5 9C6.05228 9 6.5 8.55228 6.5 8C6.5 7.44772 6.05228 7 5.5 7V9ZM3.99264 8V7V8ZM1.5 10.6478H0.5H1.5ZM0.5 11C0.5 11.5523 0.947715 12 1.5 12C2.05228 12 2.5 11.5523 2.5 11H0.5ZM12.2071 8.70711C12.5976 8.31658 12.5976 7.68342 12.2071 7.29289C11.8166 6.90237 11.1834 6.90237 10.7929 7.29289L12.2071 8.70711ZM7.79289 10.2929C7.40237 10.6834 7.40237 11.3166 7.79289 11.7071C8.18342 12.0976 8.81658 12.0976 9.20711 11.7071L7.79289 10.2929ZM9.20711 7.29289C8.81658 6.90237 8.18342 6.90237 7.79289 7.29289C7.40237 7.68342 7.40237 8.31658 7.79289 8.70711L9.20711 7.29289ZM10.7929 11.7071C11.1834 12.0976 11.8166 12.0976 12.2071 11.7071C12.5976 11.3166 12.5976 10.6834 12.2071 10.2929L10.7929 11.7071ZM5.5 7H3.99264V9H5.5V7ZM3.99264 7C3.04619 7 2.15165 7.39993 1.50196 8.09006L2.95819 9.46097C3.24342 9.15799 3.61692 9 3.99264 9V7ZM1.50196 8.09006C0.854196 8.77815 0.5 9.69916 0.5 10.6478H2.5C2.5 10.1919 2.67104 9.766 2.95819 9.46097L1.50196 8.09006ZM0.5 10.6478V11H2.5V10.6478H0.5ZM7.49411 2.98584C7.49411 3.52639 7.05296 3.97168 6.5 3.97168V5.97168C8.14968 5.97168 9.49411 4.63879 9.49411 2.98584H7.49411ZM6.5 3.97168C5.94704 3.97168 5.50589 3.52639 5.50589 2.98584H3.50589C3.50589 4.63879 4.85032 5.97168 6.5 5.97168V3.97168ZM5.50589 2.98584C5.50589 2.44529 5.94704 2 6.5 2V0C4.85032 0 3.50589 1.33289 3.50589 2.98584H5.50589ZM6.5 2C7.05296 2 7.49411 2.44529 7.49411 2.98584H9.49411C9.49411 1.33289 8.14968 0 6.5 0V2ZM10.7929 7.29289L9.29289 8.79289L10.7071 10.2071L12.2071 8.70711L10.7929 7.29289ZM9.29289 8.79289L7.79289 10.2929L9.20711 11.7071L10.7071 10.2071L9.29289 8.79289ZM7.79289 8.70711L9.29289 10.2071L10.7071 8.79289L9.20711 7.29289L7.79289 8.70711ZM9.29289 10.2071L10.7929 11.7071L12.2071 10.2929L10.7071 8.79289L9.29289 10.2071Z" fill="#FF238D"/>
      </svg>

      <svg v-if="(icon.icon && icon.icon === 'man') || icon === 'man'" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M15 16V14.9165C15 13.8632 14.6058 12.853 13.9041 12.1081C13.2024 11.3633 12.2508 10.9448 11.2584 10.9448H4.74157C3.74925 10.9448 2.79756 11.3633 2.09588 12.1081C1.3942 12.853 1 13.8632 1 14.9165V16M10.962 3.97876C10.962 5.62388 9.62186 6.95752 7.96873 6.95752C6.3156 6.95752 4.97547 5.62388 4.97547 3.97876C4.97547 2.33364 6.3156 1 7.96873 1C9.62186 1 10.962 2.33364 10.962 3.97876Z" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <span v-if="label" class="c-button-label">{{ label }}</span>

    <span v-if="appendText" class="c-button-append-text">{{ appendText }}</span>

    <span v-if="pending" class="c-button-loader">
      <font-awesome-icon :icon="loaderIcon" spin />
    </span>

    <div
      v-if="tooltip"
      class="c-button-tooltip"
      :class="{ 'c-button-tooltip-position-left': tooltip.position === 'left' }"
    >
      {{ active ? tooltip.activeText && tooltip.activeText : tooltip.text ? tooltip.text : tooltip }}
    </div>
  </button>
</template>

<script>
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "c-button",
  components: { FontAwesomeIcon },

  props: [
    "label",
    "type",
    "size",
    "icon",
    "color",
    "disabled",
    "active",
    "responsive",
    "tooltip",
    "appendText",
    "disabledButClickable",
    "pending",
  ],

  data() {
    return {
      localActive: this.active,
      loaderIcon: faSpinner,
    };
  },

  computed: {
    iconStyles() {
      return {
        "c-button-icon_success": this.icon && this.icon.color && this.icon.color === "success",
        "c-button-icon_white": this.icon && this.icon.color && this.icon.color === "white",
        "c-button-icon_secondary": this.icon && this.icon.color && this.icon.color === "secondary",
        "c-button-icon_primary": this.icon && this.icon.color && this.icon.color === "primary",
      };
    },
    buttonStyles() {
      return {
        "c-button--pending": this.pending,

        "disabled-but-clickable": this.disabledButClickable,
        "c-button_circled": this.label === undefined,
        "c-button_active": this.active,
        "c-button_responsive": this.responsive,

        "c-button_size_small": this.size === "small",
        "c-button_size_iconic": this.size === "iconic",
        "c-button_size_tiny": this.size === "tiny",

        "c-button_color_primary": this.color === "primary",
        "c-button_color_secondary": this.color === "secondary",
        "c-button_color_white": this.color === "white",

        "c-button_icon_back": (this.icon && this.icon.icon && this.icon.icon === "back") || this.icon === "back",
        "c-button_icon_check": (this.icon && this.icon.icon && this.icon.icon === "check") || this.icon === "check",
        "c-button_icon_close": (this.icon && this.icon.icon && this.icon.icon === "close") || this.icon === "close",
        "c-button_icon_comment":
          (this.icon && this.icon.icon && this.icon.icon === "comment") || this.icon === "comment",
        "c-button_icon_bookmark":
          (this.icon && this.icon.icon && this.icon.icon === "bookmark") || this.icon === "bookmark",
        "c-button_icon_favorites":
          (this.icon && this.icon.icon && this.icon.icon === "favorites") || this.icon === "favorites",
        "c-button_icon_menu": (this.icon && this.icon.icon && this.icon.icon === "menu") || this.icon === "menu",
        "c-button_icon_eye": (this.icon && this.icon.icon && this.icon.icon === "eye") || this.icon === "eye",
        "c-button_icon_trash": (this.icon && this.icon.icon && this.icon.icon === "trash") || this.icon === "trash",
        "c-button_icon_restore":
          (this.icon && this.icon.icon && this.icon.icon === "restore") || this.icon === "restore",
        "c-button_icon_box-arhive":
          (this.icon && this.icon.icon && this.icon.icon === "box-arhive") || this.icon === "box-arhive",
        "c-button_icon_edit": (this.icon && this.icon.icon && this.icon.icon === "edit") || this.icon === "edit",
        "c-button_icon_file": (this.icon && this.icon.icon && this.icon.icon === "file") || this.icon === "file",
        "c-button_icon_constructor":
          (this.icon && this.icon.icon && this.icon.icon === "constructor") || this.icon === "constructor",
        "c-button_icon_arrows-constructor":
          (this.icon && this.icon.icon && this.icon.icon === "arrows-constructor") ||
          this.icon === "arrows-constructor",
        "c-button_icon_info": (this.icon && this.icon.icon && this.icon.icon === "info") || this.icon === "info",
        "c-button_icon_info-new": (this.icon && this.icon.icon && this.icon.icon === "info-new") || this.icon === "info-new",
        "c-button_icon_filter": (this.icon && this.icon.icon && this.icon.icon === "filter") || this.icon === "filter",
        "c-button_icon_filter-tiny":
          (this.icon && this.icon.icon && this.icon.icon === "filter-tiny") || this.icon === "filter-tiny",
        "c-button_icon_time": (this.icon && this.icon.icon && this.icon.icon === "time") || this.icon === "time",
        "c-button_icon_calculate":
          (this.icon && this.icon.icon && this.icon.icon === "calculate") || this.icon === "calculate",
        "c-button_icon_need": (this.icon && this.icon.icon && this.icon.icon === "need") || this.icon === "need",
        "c-button_icon_time-is-out":
          (this.icon && this.icon.icon && this.icon.icon === "time-is-out") || this.icon === "time-is-out",
        "c-button_icon_explanatory":
          (this.icon && this.icon.icon && this.icon.icon === "explanatory") || this.icon === "explanatory",
        "c-button_icon_up": (this.icon && this.icon.icon && this.icon.icon === "up") || this.icon === "up",
        "c-button_icon_link": (this.icon && this.icon.icon && this.icon.icon === "link") || this.icon === "link",
        "c-button_icon_plus": (this.icon && this.icon.icon && this.icon.icon === "plus") || this.icon === "plus",
        "c-button_icon_plus-bold":
          (this.icon && this.icon.icon && this.icon.icon === "plus-bold") || this.icon === "plus-bold",
        "c-button_icon_times-bold":
          (this.icon && this.icon.icon && this.icon.icon === "times-bold") || this.icon === "times-bold",
        "c-button_icon_download":
          (this.icon && this.icon.icon && this.icon.icon === "download") || this.icon === "download",
        "c-button_icon_change-history":
          (this.icon && this.icon.icon && this.icon.icon === "change-history") || this.icon === "change-history",
        "c-button_icon_mark-as-employee":
          (this.icon && this.icon.icon && this.icon.icon === "mark-as-employee") || this.icon === "mark-as-employee",
        "c-button_icon_unmark-employee":
          (this.icon && this.icon.icon && this.icon.icon === "unmark-employee") || this.icon === "unmark-employee",
        "c-button_icon_employee":
          (this.icon && this.icon.icon && this.icon.icon === "employee") || this.icon === "employee",
        "c-button_icon_expiration-date":
          (this.icon && this.icon.icon && this.icon.icon === "expiration-date") || this.icon === "expiration-date",
        "c-button_icon_new-line":
          (this.icon && this.icon.icon && this.icon.icon === "new-line") || this.icon === "new-line",
        "c-button_icon_copy-to-clipboard":
          (this.icon && this.icon.icon && this.icon.icon === "copy-to-clipboard") || this.icon === "copy-to-clipboard",
        "c-button_icon_point": (this.icon && this.icon.icon && this.icon.icon === "point") || this.icon === "point",
        "c-button_icon_home": (this.icon && this.icon.icon && this.icon.icon === "home") || this.icon === "home",
        "c-button_icon_settings":
          (this.icon && this.icon.icon && this.icon.icon === "settings") || this.icon === "settings",
        "c-button_icon_fill": (this.icon && this.icon.icon && this.icon.icon === "fill") || this.icon === "fill",
        "c-button_icon_less": (this.icon && this.icon.icon && this.icon.icon === "less") || this.icon === "less",
        "c-button_icon_more": (this.icon && this.icon.icon && this.icon.icon === "more") || this.icon === "more",
        "c-button_icon_routes": (this.icon && this.icon.icon && this.icon.icon === "routes") || this.icon === "routes",
        "c-button_icon_chevron":
          (this.icon && this.icon.icon && this.icon.icon === "chevron") || this.icon === "chevron",
        "c-button_icon_money": (this.icon && this.icon.icon && this.icon.icon === "money") || this.icon === "money",

        "c-button_tooltip": this.tooltip,
        "c-button_tooltip_bottom": this.tooltip && this.tooltip.position && this.tooltip.position === "bottom",
        "c-button_tooltip_left": this.tooltip && this.tooltip.position && this.tooltip.position === "left",
        "c-button_tooltip_right": this.tooltip && this.tooltip.position && this.tooltip.position === "right",
      };
    },
  },

  watch: {
    active(value) {
      this.localActive = value;
      this.buttonStyles["c-button_active"] = value;
    },
  },

  methods: {
    onClick(evt) {
      this.$emit("click", evt);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-button {
  cursor: pointer;
  background: none;
  border: 1px solid $color-button-border;
  height: 38px;
  border-radius: 19px;
  padding: 0 30px;
  color: #000;
  white-space: nowrap;
  transition: 0.2s;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  font: {
    size: 15px;
    weight: 500;
  }
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;

  &:focus {
    outline: none;
  }

  &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }

  &:hover {
    border-color: $color-button-border-hover;
  }

  &:active {
    border-color: $color-button-border-clicked;
  }

  &_active {
    svg {
      fill: $color-primary;

      &.c-button-icon_stroked {
        stroke: $color-primary;
      }
    }
  }

  &_color {
    &_primary,
    &_secondary {
      color: white;

      .c-button-icon {
        svg {
          fill: white;
        }

        &_stroked {
          stroke: white;

          path {
            stroke: inherit;
          }
        }
      }
    }

    &_primary {
      background: $color-primary;
      border-color: $color-primary;

      &:hover {
        background: $color-primary-hover;
        border-color: $color-primary-hover;
      }

      &:active {
        background: $color-primary-clicked;
        border-color: $color-primary-clicked;
      }
    }

    &_secondary {
      background: $color-secondary;
      border-color: $color-secondary;

      &:hover {
        background: darken($color-secondary, 10%);
        border-color: darken($color-secondary, 10%);
      }

      &:active {
        background: darken($color-secondary, 20%);
        border-color: darken($color-secondary, 20%);
      }
    }

    &_white {
      background: #ffffff;
    }
  }

  &-icon {
    display: flex;
    align-items: center;
    margin-right: 10px;
    margin-left: -4px;

    svg {
      fill: $color-label;
    }

    &_stroked {
      stroke: $color-label;
      fill: none !important;

      &.c-button-icon_primary {
        stroke: $color-primary !important;

      }

      &_success {
        stroke: $color-success !important;
      }
    }

    &_success {
      svg {
        fill: $color-success;
      }
    }

    &_secondary {
      svg,
      path {
        fill: $color-secondary;
      }
    }

    &_primary {
      svg {
        fill: $color-primary;
      }
    }
  }

  &_circled {
    padding: 0;
    border-radius: 50%;
    justify-content: center;
    text-align: center;
    width: 38px;
    position: relative;

    .c-button-icon {
      margin: 0;
      position: absolute;
      top: 50%;
      left: 50%;
    }

    &.c-button_icon {
      &_back {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -5px;
        }
      }

      &_check {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -5px;
        }
      }

      &_close {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -5px;
        }
      }

      &_comment {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -7px;
        }

        &.c-button_active {
          background: $color-primary;
          border-color: $color-primary;

          .c-button-icon {
            svg path {
              stroke: #ffffff;
            }
          }
        }
      }

      &_bookmark {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -7px;
        }

        &.c-button_active {
          background: $color-primary;
          border-color: $color-primary;

          .c-button-icon {
            svg {
              stroke: white;
            }
          }
        }
      }

      &_favorites {
        .c-button-icon {
          margin-left: -10px;
          margin-top: -11px;
        }

        &.c-button_active {
          .c-button-icon {
            svg path {
              fill: $color-primary;
              stroke: $color-primary;
            }
          }
        }
      }

      &_menu {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -5px;
        }
      }

      &_eye {
        .c-button-icon {
          margin-left: -10px;
          margin-top: -6px;
        }
      }

      &_trash {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -6px;
        }
      }

      &_restore {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -6px;
        }
      }

      &_box-arhive {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_file {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }
      }

      &_money {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -6px;

          svg {
            fill: none;
            stroke: $color-label;
          }
        }
      }

      &_edit {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_arrows-constructor {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }
      }

      &_info {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_filter {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -6px;
        }
      }

      &_filter-tiny {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -6px;

          svg {
            fill: none;
            stroke: $color-label;
          }
        }

        &.c-button_active {
          .c-button-icon {
            svg {
              stroke: $color-primary;
              fill: $color-primary;
            }
          }
        }
      }

      &_time {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;

          svg {
            fill: none;
            stroke: $color-label;
          }
        }
      }

      &_calculate {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;

          svg {
            fill: none;
            stroke: $color-label;
          }
        }
      }

      &_need {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }

        svg {
          fill: none;
          stroke: $color-label;
        }
      }

      &_time-is-out {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }

        svg {
          fill: none;
        }
      }

      &_explanatory {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }

        svg {
          fill: none;
        }
      }

      &_up {
        .c-button-icon {
          margin-left: -5px;
          margin-top: -7px;
        }

        svg {
          fill: none;
        }
      }

      &_link {
        .c-button-icon {
          margin-left: -5px;
          margin-top: -7px;
        }

        svg {
          fill: none;
        }
      }

      &_plus {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_plus-bold {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_times-bold {
        .c-button-icon {
        }
      }

      &_download {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_change-history {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -7px;
        }
      }

      &_mark-as-employee {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -8px;
        }
      }

      &_unmark-employee {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -8px;
        }
      }

      &_employee {
        .c-button-icon {
          margin-left: -6px;
          margin-top: -8px;
        }
      }

      &_expiration-date {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }
      }

      &_new-line {
        .c-button-icon {
          margin-left: -5px;
          margin-top: -5px;
        }
      }

      &_copy-to-clipboard {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -7px;
        }
      }

      &_point {
        .c-button-icon {
          margin-left: -7px;
          margin-top: -8px;
        }
      }

      &_home {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -8px;
        }
      }

      &_settings {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -8px;
        }
        &.c-button_active {
          .c-button-icon {
            svg {
              stroke: $color-primary;
              fill: $color-primary;
            }
          }
        }
      }

      &_fill {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -8px;
        }
      }

      &_less {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -8px;
        }
      }

      &_more {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -8px;
        }
      }

      &_routes {
        .c-button-icon {
          margin-left: -8px;
          margin-top: -8px;
        }
      }
    }
  }

  &_size {
    &_small {
      height: 30px;
      border-radius: 15px;
      padding: 0 14px;
      font: {
        size: 12px;
      }

      &.c-button_circled {
        width: 30px;
        padding: 0;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .c-button-tooltip {
        bottom: 30px !important;
      }

      &:hover {
        .c-button-tooltip {
          bottom: 34px !important;
        }
      }
    }

    &_iconic {
      width: 20px;
      height: 20px;
      border: none;

      .c-button-tooltip {
        bottom: 20px !important;
      }

      &:hover {
        .c-button-tooltip {
          bottom: 24px !important;
        }
      }
    }

    &_tiny {
      border: none;
      width: 14px;
      height: 14px;

      .c-button-tooltip {
        bottom: 14px;
      }

      &:hover {
        .c-button-tooltip {
          bottom: 18px !important;
        }
      }
    }
  }

  &_tooltip {
    &_bottom {
      &.c-button_size {
        &_tiny {
          .c-button-tooltip {
            bottom: auto !important;
            top: 14px;
            left: auto !important;
            right: auto !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: 18px !important;
              left: auto !important;
              right: auto !important;
            }
          }
        }
      }
    }

    &_left {
      &.c-button_size {
        &_tiny {
          .c-button-tooltip {
            bottom: auto !important;
            top: auto !important;
            right: 14px !important;
            left: auto !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: auto !important;
              right: 18px !important;
              left: auto !important;
            }
          }
        }

        &_iconic {
          .c-button-tooltip {
            bottom: auto !important;
            top: auto !important;
            right: 20px !important;
            left: auto !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: auto !important;
              right: 24px !important;
              left: auto !important;
            }
          }
        }

        &_small {
          .c-button-tooltip {
            bottom: auto !important;
            top: auto !important;
            right: 30px !important;
            left: auto !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: auto !important;
              right: 34px !important;
              left: auto !important;
            }
          }
        }
      }
    }

    &_right {
      &.c-button_size {
        &_tiny {
          .c-button-tooltip {
            bottom: auto !important;
            top: auto !important;
            right: auto !important;
            left: 14px !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: auto !important;
              right: auto !important;
              left: 18px !important;
            }
          }
        }

        &_iconic {
          .c-button-tooltip {
            bottom: auto !important;
            top: auto !important;
            right: auto !important;
            left: 20px !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: auto !important;
              right: auto !important;
              left: 24px !important;
            }
          }
        }

        &_small {
          .c-button-tooltip {
            bottom: auto !important;
            top: auto !important;
            right: auto !important;
            left: 30px !important;
          }

          &:hover {
            .c-button-tooltip {
              bottom: auto !important;
              top: auto !important;
              right: auto !important;
              left: 34px !important;
            }
          }
        }
      }
    }
  }

  &-append-text {
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
    color: $label;
  }

  &_responsive {
    @media (max-width: 767px) {
      padding: 0;
      border-radius: 50%;
      justify-content: center;
      text-align: center;
      width: 30px;

      .c-button-icon {
        margin-right: 0 !important;
        margin-left: 0 !important;
      }

      .c-button-label {
        display: none;
      }
    }
  }

  &-tooltip {
    position: absolute;
    background: white;
    font-size: 11px;
    box-shadow: $box-shadow-tooltip;
    padding: 6px 10px;
    border-radius: $border-radius-tooltip;
    z-index: 9999;
    bottom: 0;
    text-align: center;
    line-height: 16px;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s;
    font-weight: 400;

    &-position-left {
      right: 0;
    }
  }

  @media (hover: hover) {
    &:hover {
      .c-button-tooltip {
        opacity: 1;
        visibility: visible;
        bottom: 0;
      }
    }
  }

  .c-button-loader {
    display: none;
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: inherit;
    background: rgba(255, 255, 255, 0.85);
    align-items: center;
    justify-content: center;
    color: $pink;
    pointer-events: none;
    cursor: default;
  }

  &--pending {
    .c-button-loader {
      display: flex;
    }
  }
}

.disabled-but-clickable {
  background-color: #87b6fd;
  border-color: #87b6fd;
}
</style>
